<template>
  <div id="home-new" >


    <div class="desk" :style="{'height': layoutHeight + 'px'}">
      <!-- 长者名册 -->
      <section class="roster">
        <header class="roster-head">
          <div class="roster-title">
            <h2>长者名册</h2>
            <span class="roster-count"><b>{{agedHealthTable.page.total}}</b>位</span>
          </div>
          <el-form class="roster-search" size="small" :inline="true" @submit.native.prevent>
            <el-input v-model="agedHealthTable.condition.agedName" placeholder="姓名" clearable
                      class="search-name" @keyup.enter.native="searchAged"></el-input>
            <el-input v-model="agedHealthTable.condition.idCard" placeholder="证件号" clearable
                      class="search-card" @keyup.enter.native="searchAged"></el-input>
            <el-input v-model="agedHealthTable.condition.location" placeholder="地址" clearable
                      class="search-location" @keyup.enter.native="searchAged"></el-input>
            <el-button type="primary" icon="el-icon-search" @click="searchAged">搜索</el-button>
            <el-button class="search-reset" @click="resetAgedSearch">重置</el-button>
          </el-form>
        </header>

        <div v-if="agedHealthTable.data && agedHealthTable.data.length" class="stage"
             @mouseenter="pauseSpot" @mouseleave="resumeSpot">
          <!-- 聚光灯：当前焦点长者，背后两层叠放的卡片边缘 -->
          <div class="spot-deck" @mousemove="tiltSpot" @mouseleave="untiltSpot">
            <transition name="spot-ink" :duration="{enter: 1400, leave: 900}">
              <div class="spotlight" :key="'spot-' + spot.id" :style="[hueStyle(spot), {'--dir': spotDir}]"
                   :class="{'is-alarm': isAlarm(spot), 'has-events': spotEvents.length}">
                <div class="spot-surface">
                  <span class="spot-watermark" aria-hidden="true">{{monogram(spot.agedName)}}</span>

                  <div class="spot-top">
                    <span class="spot-sex">
                      <i :class="spot.agedSex == '女' ? 'el-icon-female' : 'el-icon-male'"></i>{{spot.agedSex || '性别未知'}}
                    </span>
                    <span class="spot-state"><i class="state-dot"></i>{{spot.pageText || '无未处理告警'}}</span>
                    <div class="spot-controls">
                      <span class="spot-index"><b>{{spotIndex + 1}}</b>/{{agedHealthTable.data.length}}</span>
                      <button type="button" title="上一位" @click="stepSpot(-1)"><i class="el-icon-arrow-left"></i></button>
                      <button type="button" :title="spotAuto ? '暂停轮播' : '开始轮播'" @click="toggleSpotAuto">
                        <i :class="spotAuto ? 'el-icon-video-pause' : 'el-icon-video-play'"></i>
                      </button>
                      <button type="button" title="下一位" @click="stepSpot(1)"><i class="el-icon-arrow-right"></i></button>
                    </div>
                  </div>

                  <div class="spot-body">
                    <a href="javascript:void(0);" class="spot-portrait" :title="'查看' + spot.agedName + '的档案'" @click="choice(spot.id)">
                      <img v-if="photoOf(spot)" :src="photoOf(spot)" alt="" @error="iconBroken(spot.icon)">
                      <template v-else-if="spotFigure">
                        <svg class="spot-figure" viewBox="20 18 120 120" aria-hidden="true">
                          <path v-if="spotFigure.back" class="fig-hair" :d="spotFigure.back"/>
                          <path class="fig-body" d="M14 170C16 130 42 112 80 110C118 112 144 130 146 170Z"/>
                          <rect class="fig-neck" x="71" y="84" width="18" height="30" rx="7"/>
                          <template v-if="spotFigure.female">
                            <path class="fig-skin" d="M66 110C70 124 90 124 94 110Z"/>
                            <path class="fig-seam" d="M66 110C72 128 76 146 76 170M94 110C88 128 84 146 84 170"/>
                            <circle class="fig-button" cx="80" cy="138" r="2.6"/>
                            <circle class="fig-button" cx="80" cy="154" r="2.6"/>
                          </template>
                          <template v-else>
                            <path class="fig-shirt" d="M68 111L80 132L92 111Z"/>
                            <path class="fig-collar" d="M68 110L62 122L77 127ZM92 110L98 122L83 127Z"/>
                          </template>
                          <g v-if="!spotFigure.noEars" class="fig-neck">
                            <ellipse cx="56" cy="68" rx="5" ry="8"/>
                            <ellipse cx="104" cy="68" rx="5" ry="8"/>
                          </g>
                          <ellipse class="fig-skin" cx="80" cy="66" rx="24" ry="28"/>
                          <path class="fig-hair" :d="spotFigure.front"/>
                          <path v-if="spotFigure.cap" class="fig-cap" :d="spotFigure.cap"/>
                          <path v-if="spotFigure.brim" class="fig-brim" :d="spotFigure.brim"/>
                          <path v-if="spotFigure.band" class="fig-band" :d="spotFigure.band"/>
                        </svg>
                        <span class="spot-seal">{{monogram(spot.agedName)}}</span>
                      </template>
                      <span v-else class="spot-monogram">{{monogram(spot.agedName)}}</span>
                    </a>

                    <div class="spot-main">
                      <h3 class="spot-name" :title="spot.agedName">{{spot.agedName}}</h3>
                      <div v-if="spotAge || spotAbility" class="spot-meta">
                        <span v-if="spotAge" class="meta-age"><b>{{spotAge}}</b>岁</span>
                        <span v-if="spotAbility" class="meta-ability" :class="'is-' + spotAbility.level"
                              :title="'能力等级：' + spot.agedAbility">{{spotAbility.label}}</span>
                      </div>
                      <div class="spot-phone" :class="{'is-empty': !spot.phone}">
                        <i class="el-icon-phone-outline"></i>{{spot.phone || '未登记电话'}}
                      </div>
                      <div class="spot-devices">
                        <button v-for="group in spotDevices" :key="group.key" type="button" class="device-chip"
                                :class="'is-' + group.state" :title="group.title" @click="openDeviceGroup(group)">
                          <i :class="group.icon"></i>{{group.label}}<em v-if="group.devices.length > 1">×{{group.devices.length}}</em>
                          <span class="device-dot"></span>
                        </button>
                        <span v-if="!spotDevices.length" class="device-none">未绑定在用设备</span>
                      </div>
                      <div class="spot-actions">
                        <button type="button" class="spot-btn is-primary" @click="choice(spot.id)">查看档案</button>
                        <button type="button" class="spot-btn" @click="GetGJXX(spot.id)">告警记录</button>
                        <button v-if="sleepBeltIcon(spot)" type="button" class="spot-btn" @click="ceshi(spot.id)">
                          <i class="el-icon-moon-night"></i>睡眠报告
                        </button>
                      </div>
                    </div>

                    <div v-if="spotEvents.length" class="spot-events">
                      <h4>近期告警</h4>
                      <ol>
                        <li v-for="(event, index) in spotEvents" :key="event.id || index" :class="'level-' + eventLevel(event.content)">
                          <span class="spot-event-time">
                            <b>{{eventClock(event.createTime)}}</b>
                            <small>{{eventDay(event.createTime)}}</small>
                          </span>
                          <span class="spot-event-text">{{eventParts(event.content).text}}</span>
                        </li>
                      </ol>
                    </div>
                  </div>

                  <span v-if="spotAuto" class="spot-progress" :key="'progress-' + spotTick"
                        :class="{'is-paused': spotHover}" :style="{'animation-duration': spotInterval + 'ms'}"></span>
                </div>
              </div>
            </transition>
          </div>

          <!-- 头像条：Cover Flow，当前长者居中 -->
          <div class="strip">
            <ol class="strip-list">
              <li v-for="(item, index) in agedHealthTable.data" :key="item.id || index" :style="coverStyle(index)">
                <button type="button" class="strip-item" :title="item.agedName" :style="hueStyle(item)"
                        :class="{'is-active': index === spotIndex, 'is-alarm': isAlarm(item)}"
                        @click="selectSpot(index)">
                  <span class="strip-photo">
                    <img v-if="photoOf(item)" :src="photoOf(item)" alt="" @error="iconBroken(item.icon)">
                    <span v-else class="strip-monogram">{{monogram(item.agedName)}}</span>
                    <i v-if="sleepBeltIcon(item)" class="strip-belt el-icon-moon-night" title="已绑定睡眠带"></i>
                  </span>
                  <span class="strip-name">{{item.agedName}}</span>
                </button>
              </li>
            </ol>
            <div class="strip-foot">
              <span class="strip-caption">本页 {{agedHealthTable.data.length}} 位长者</span>
              <el-pagination
                  small
                  @current-change="handleCurrentChange"
                  @size-change="handleAgedSizeChange"
                  :current-page.sync="agedHealthTable.page.currentPage"
                  :page-sizes="[12, 24, 48]"
                  :page-size.sync="agedHealthTable.page.pageSize"
                  layout="sizes, prev, pager, next"
                  :total="agedHealthTable.page.total">
              </el-pagination>
            </div>
          </div>
        </div>
        <div v-else class="roster-empty">
          <i class="el-icon-user"></i>
          <p>没有找到符合条件的长者</p>
          <el-button size="small" @click="resetAgedSearch">清空搜索条件</el-button>
        </div>
      </section>

      <!-- 值守台：实时告警 + 设备告警统计 -->
      <aside class="console">
        <div class="console-head">
          <div class="console-title">
            <span class="live-dot"></span>
            <h3>实时告警</h3>
          </div>
          <button type="button" class="console-refresh" title="刷新告警" @click="loadEvents">
            <i class="el-icon-refresh-right"></i>
          </button>
        </div>

        <div class="feed">
          <template v-if="events && events.length">
            <a href="javascript:void(0);" class="feed-latest" :class="'level-' + eventLevel(events[0].content)"
               @click="choice(events[0].agedId)">
              <div class="feed-latest-top">
                <span class="feed-latest-tag">最新</span>
                <span class="feed-latest-time">{{events[0].createTime}}</span>
              </div>
              <div class="feed-latest-name">{{eventParts(events[0].content).name || '未知长者'}}</div>
              <p class="feed-latest-text">{{eventParts(events[0].content).text}}</p>
            </a>
            <ol class="feed-list">
              <li v-for="(event, index) in events.slice(1)" :key="event.id || index">
                <a href="javascript:void(0);" class="feed-item" :class="'level-' + eventLevel(event.content)"
                   @click="choice(event.agedId)">
                  <span class="feed-time">
                    <b>{{eventClock(event.createTime)}}</b>
                    <small>{{eventDay(event.createTime)}}</small>
                  </span>
                  <span class="feed-rail"></span>
                  <span class="feed-body">
                    <b v-if="eventParts(event.content).name">{{eventParts(event.content).name}}</b>
                    {{eventParts(event.content).text}}
                  </span>
                </a>
              </li>
            </ol>
          </template>
          <div v-else class="feed-empty">
            <i class="el-icon-circle-check"></i>
            <p>当前没有告警</p>
          </div>
        </div>

        <div class="stats">
          <div class="stats-head">
            <h3>设备告警统计</h3>
            <span class="stats-total"><b>{{alarmTotal}}</b>次</span>
          </div>
          <div id="data_2" class="stats-chart"></div>
        </div>
      </aside>
    </div>

    <el-dialog v-if="NBiotEventTableVisible" :title="NBiotEventTableTitle" :visible.sync="NBiotEventTableVisible" :close-on-click-modal="false" width="70%">
      <el-row :gutter="20" class="out-border">
        <el-col :span="24">
          <div class="page-content">
            <div>
              <el-table :data="NBiotEventTable.data" highlight-current-row>
                <el-table-column prop="agedName" label="告警老人"></el-table-column>
                <el-table-column prop="status" label="状态">
                  <template scope="scope">
                    <span v-if="scope.row.status==='报警'" style="color: green">已处理（报警）</span>
                    <span v-if="scope.row.status==='测试'" style="color: green">已处理（测试）</span>
                    <span v-if="scope.row.status==='误报'" style="color: green">已处理（误报）</span>
                    <span v-if="scope.row.status==='演练'" style="color: green">已处理（演练）</span>
                    <span v-if="scope.row.status==='告警'" style="color: red">发生告警</span>
                  </template>
                </el-table-column>
                <el-table-column prop="type" label="设备类型">
                  <template scope="scope">
                    <span v-if="scope.row.type==='SOS'" >SOS告警</span>
                    <span v-if="scope.row.type==='GAS'" >燃气告警</span>
                    <span v-if="scope.row.type==='WATER'" >水浸告警</span>
                    <span v-if="scope.row.type==='Smoke'" >烟雾告警</span>
                    <span v-if="scope.row.type==='Infrared'" >红外告警</span>
                    <span v-if="scope.row.type==='DOOR'" >门磁告警</span>
                  </template>
                </el-table-column>
                <el-table-column prop="textAged" label="处理人"></el-table-column>
                <el-table-column prop="createTime" label="告警时间"></el-table-column>
                <el-table-column prop="content" label="告警信息"></el-table-column>
                <el-table-column prop="textRead" label="处理方式"></el-table-column>
                <el-table-column prop="textText" label="处理结果"></el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope" >
                    <el-button size="mini" type="text" @click="handleNBiotEdit(scope.row.id)">处理</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pagination">
              <el-pagination
                  @current-change="handleCurrentChange"
                  @size-change="NBiotEventTable"
                  :current-page.sync="NBiotEventTable.page.currentPage"
                  :page-sizes="[10, 50, 100]"
                  :page-size.sync="NBiotEventTable.page.pageSize"
                  layout="sizes,  prev, pager, next, total"
                  :total="NBiotEventTable.page.total">
              </el-pagination>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-dialog>

    <!--    新增页面  编辑页面-->
    <el-dialog v-if="NBiotDialogVisible" :title="NBiotDialogTitle" :visible.sync="NBiotDialogVisible" :close-on-click-modal="false">
      <el-form :model="NBiotEventInfo" ref="NBiotForm"  size="small">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="老人" prop="agedName" :label-width="lableWidth" >
              <el-input v-model="NBiotEventInfo.agedName" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!--            <el-row :gutter="20">-->
        <!--                <el-col :span="12">-->
        <!--                    <el-form-item label="imei号" prop="imei" :label-width="lableWidth">-->
        <!--                        <el-input v-model="NBiotEventInfo.imei" :disabled="true"></el-input>-->
        <!--                    </el-form-item>-->
        <!--                </el-col>-->
        <!--            </el-row>-->
        <el-row :gutter="20">
          <el-col :span="20">
            <el-form-item label="告警信息" prop="content" :label-width="lableWidth">
              <el-input v-model="NBiotEventInfo.content" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="告警处理" prop="status" :label-width="lableWidth">
              <el-select v-model="NBiotEventInfo.status" placeholder="请选择">
                <el-option label="误报" value="误报"></el-option>
                <el-option label="演练" value="演练"></el-option>
                <el-option label="测试" value="测试"></el-option>
                <el-option label="报警" value="报警"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="处理人" prop="text_aged" :label-width="lableWidth" >
              <el-input v-model="NBiotEventInfo.textAged" placeholder="请输入处理人"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20">
            <el-form-item label="处理方式" :label-width="lableWidth">
              <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入处理方式"
                  v-model="NBiotEventInfo.textRead">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20">
            <el-form-item label="处理结果" :label-width="lableWidth">
              <el-input
                  type="textarea"
                  :rows="4"
                  placeholder="请输入处理结果"
                  v-model="NBiotEventInfo.textText">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="NBiotDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleUpd">确 定</el-button>
      </div>
    </el-dialog>


    <el-dialog v-if="reportDialog.visible" :title="reportDialog.title"
               :visible.sync="reportDialog.visible" top="3%"
               width="70%">
      <el-row :gutter="20">
        <el-col :span="24">
          <div style="text-align: center">
            <template  v-if="reportDialog.message">
              <el-divider>实时数据</el-divider>
              <el-row :gutter="20">
                <el-col :span="8">
                  <p>{{reportDialog.message.sn}}</p>
                  <p>设备号</p>
                </el-col>
                <el-col :span="8">
                  <p v-if="reportDialog.message.timestamp">{{reportDialog.message.timestamp}}</p>
                  <p>数据时间</p>
                </el-col>
                <el-col :span="8">
                  <p>{{reportDialog.message.heartRate}}</p>
                  <p>实时心率</p>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="8">
                  <p>{{reportDialog.message.breath}}</p>
                  <p>实时呼吸</p>
                </el-col>
                <el-col :span="8">
                  <p>{{reportDialog.message.status}}</p>
                  <p>实时状态</p>
                </el-col>
                <el-col :span="8">
                  <p>{{reportDialog.message.power}}</p>
                  <p>电量</p>
                </el-col>
              </el-row>
            </template>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <div style="text-align: center">
            <div>
              <el-divider>香睡指数</el-divider>
              <p style="font-size: 30px;font-weight: bold;line-height: 30px">{{reportDialog.data.score.d}}</p>
              <p style="font-size: 20px;line-height: 30px">{{reportDialog.data.score_desc}}</p>
            </div>
            <div style="margin-top: 50px">
              <el-divider>睡眠总时长</el-divider>
              <p style="font-size: 16px;line-height: 20px">{{reportDialog.data.total_duration.h}}小时{{reportDialog.data.total_duration.m}}分钟</p>
              <p style="font-size: 16px;line-height: 20px">{{reportDialog.data.gobed_time.d}} - {{reportDialog.data.outbed_time}}</p>
            </div>
          </div>
        </el-col>
        <el-col :span="16">
          <el-divider>各项睡眠监测数据统计</el-divider>
          <el-row :gutter="20">
            <el-col :span="8">
              <p :class="'d-'+reportDialog.data.gobed_time.s">{{reportDialog.data.gobed_time.d}}</p>
              <p>上床时间</p>
            </el-col>
            <el-col :span="8">
              <p :class="'d-'+reportDialog.data.inbed_duration.s">{{reportDialog.data.inbed_duration.h}}小时{{reportDialog.data.inbed_duration.m}}分钟</p>
              <p>在床时间</p>
            </el-col>
            <el-col :span="8">
              <p :class="'d-'+reportDialog.data.deep_duration.s">{{reportDialog.data.deep_duration.h}}小时{{reportDialog.data.deep_duration.m}}分钟</p>
              <p>深睡时长</p>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <p :class="'d-'+reportDialog.data.outbed_num.s">{{reportDialog.data.outbed_num.d}}次</p>
              <p>离床次数</p>
            </el-col>
            <el-col :span="8">
              <p :class="'d-'+reportDialog.data.move_num.s">{{reportDialog.data.move_num.d}}次</p>
              <p>体动次数</p>
            </el-col>
            <el-col :span="8">
              <p :class="'d-'+reportDialog.data.snoring_num.s">{{reportDialog.data.snoring_num.d}}次</p>
              <p>打鼾次数</p>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <p :class="'d-'+reportDialog.data.avg_hx.s">{{reportDialog.data.avg_hx.d}}次/分</p>
              <p>平均呼吸率</p>
            </el-col>
            <el-col :span="8">
              <p :class="'d-'+reportDialog.data.avg_rh.s">{{reportDialog.data.avg_rh.d}}次/分</p>
              <p>平均心率</p>
            </el-col>
            <el-col :span="8">
              <p :class="'d-'+reportDialog.data.sleep_eff.s">{{reportDialog.data.sleep_eff.d}}</p>
              <p>睡眠效率</p>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-divider>呼吸(次/分)</el-divider>
          <div id="hx-bar" style="height: 300px"></div>
        </el-col>
        <el-col :span="12">
          <el-divider>心率(次/分)</el-divider>
          <div id="xl-line" style="height: 300px"></div>
        </el-col>
      </el-row>
    </el-dialog>

    <!-- 首页长者卡片：设备详情（睡眠雷达看实时体征，NB-IoT 看设备清单） -->
    <el-dialog :title="deviceDialog.title" :visible.sync="deviceDialog.visible" width="640px"
               custom-class="device-dialog">
      <template v-if="deviceDialog.kind === 'radar'">
        <section v-for="radar in deviceDialog.devices" :key="radar.id" class="radar-card">
          <header class="radar-head">
            <span class="device-state" :class="radar.online ? 'is-online' : 'is-offline'">{{radar.online ? '在线' : '离线'}}</span>
            <span class="radar-imei">IMEI {{radar.deviceNo || '--'}}</span>
            <span class="radar-time">最近心跳 {{radar.lastTime || '--'}}</span>
          </header>
          <div v-if="radarLive(radar).loading" class="radar-tip"><i class="el-icon-loading"></i>正在读取实时数据…</div>
          <div v-else-if="radarLive(radar).error" class="radar-tip">{{radarLive(radar).error}}</div>
          <template v-else>
            <div class="radar-presence" :class="{'is-empty': !radarView(radar).present}">
              <i :class="radarView(radar).present ? 'el-icon-user-solid' : 'el-icon-user'"></i>
              {{radarView(radar).present ? '床上有人 · ' + radarView(radar).sleep : '床上无人'}}
            </div>
            <dl class="radar-grid">
              <div><dt>心率</dt><dd><b>{{radarView(radar).heart}}</b><small>次/分</small></dd></div>
              <div><dt>呼吸</dt><dd><b>{{radarView(radar).breath}}</b><small>次/分</small></dd></div>
              <div><dt>呼吸状态</dt><dd>{{radarView(radar).breathState}}</dd></div>
              <div><dt>体动</dt><dd>{{radarView(radar).move}}</dd></div>
            </dl>
          </template>
        </section>
      </template>
      <el-table v-else class="device-dialog-table" :data="deviceDialog.devices" size="small" :row-class-name="deviceRowClass">
        <el-table-column label="设备" min-width="120">
          <template slot-scope="scope">
            <i :class="deviceGroupOf(scope.row).icon" class="device-cell-icon"></i>{{scope.row.type}}
          </template>
        </el-table-column>
        <el-table-column label="IMEI" prop="deviceNo" min-width="150"></el-table-column>
        <el-table-column label="状态" width="90">
          <template slot-scope="scope">
            <span class="device-state" :class="scope.row.online ? 'is-online' : 'is-offline'">{{scope.row.online ? '在线' : '离线'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="电量" width="70">
          <template slot-scope="scope">{{scope.row.battery != null ? scope.row.battery + '%' : '--'}}</template>
        </el-table-column>
        <el-table-column label="最近心跳" prop="lastTime" min-width="150">
          <template slot-scope="scope">{{deviceLastTime(scope.row)}}</template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog v-if="HomeVisible" :title="HomeTitle" :visible.sync="HomeVisible" :close-on-click-modal="false" width="70%">
      <template>
        <el-tabs v-model="activeName" >
          <el-tab-pane label="老人档案" name="first">
            <div class="dialog-page" :style="{'height':($store.state.minPageHeight - 300) +'px'}">
              <el-scrollbar style="height: 100%">
                <div style="display: flex">
                  <div style="width: 120px">
                    <el-steps direction="vertical" :space="0" finish-status="success">
                      <el-step title="基本信息" status="process" style="min-height: 1100px"></el-step>
                      <el-step title="提交" status="success"></el-step>
                    </el-steps>
                  </div>
                  <div style="width: 100%;padding: 20px">
                    <el-row style="padding-top: 30px">
                      <el-col :span="24">
                        <el-form ref="aged-form" :model="agedDialog.form" :rules="agedDialog.rules"
                                 label-width="120px"
                                 size="small">
                          <div>
                            <el-row :gutter="20">
                              <el-col :span="12">
                                <el-form-item label="姓名" prop="agedName">
                                  <el-input v-model="agedDialog.form.agedName"
                                            placeholder="请输入姓名"></el-input>
                                </el-form-item>
                              </el-col>
                              <el-col :span="12">
                                <el-form-item label="性别">
                                  <el-radio v-model="agedDialog.form.agedSex" :label="1">男</el-radio>
                                  <el-radio v-model="agedDialog.form.agedSex" :label="0">女</el-radio>
                                </el-form-item>
                              </el-col>
                            </el-row>

                            <el-row :gutter="20">
                              <el-col :span="12">
                                <el-form-item label="证件号" prop="idCard">
                                  <el-input v-model="agedDialog.form.idCard"
                                            placeholder="请输入证件号"></el-input>
                                </el-form-item>
                              </el-col>
                              <el-col :span="12">
                                <el-form-item label="证件类型">
                                  <el-select v-model="agedDialog.form.cardType" placeholder="请选择证件类型">
                                    <el-option label="身份证" value="ID_CARD"></el-option>
                                    <el-option label="驾驶证" value="DRIVER_LICENSE"></el-option>
                                    <el-option label="护照" value="PASS_PORT"></el-option>
                                    <el-option label="临时" value="TEMPORARY"></el-option>
                                  </el-select>
                                </el-form-item>
                              </el-col>
                            </el-row>

                            <el-row :gutter="20">

                              <el-col :span="12">
                                <el-form-item label="联系电话" prop="phone">
                                  <el-input v-model="agedDialog.form.phone"
                                            placeholder="请输入联系电话"></el-input>
                                </el-form-item>
                              </el-col>
                            </el-row>


                            <el-row :gutter="20">
                              <el-col :span="12">
                                <el-form-item label="本市户籍">
                                  <el-select v-model="agedDialog.form.isLocal"
                                             placeholder="请选择是否本地户籍">
                                    <el-option label="是" :value="true"></el-option>
                                    <el-option label="否" :value="false"></el-option>
                                  </el-select>
                                </el-form-item>
                              </el-col>

                            </el-row>


                            <el-row :gutter="20">
                              <el-col :span="12">
                                <el-form-item label="类别">
                                  <el-row>
                                    <el-col :span="24">
                                      <el-select v-model="agedDialog.form.agedType" filterable
                                                 placeholder="请选择长者类型">
                                        <el-option
                                            v-for="item in agedTypes"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                        </el-option>
                                      </el-select>
                                    </el-col>
                                  </el-row>
                                </el-form-item>
                              </el-col>

                            </el-row>
                            <el-row :gutter="20">
                              <el-col :span="8">
                                <el-form-item label="服务地址" prop="province" >
                                  <el-select v-model="agedDialog.form.province" placeholder="省" @change="getCitys" clearable>
                                    <el-option
                                        v-for="item in provinces"
                                        :key="item.id"
                                        :label="item.regionName"
                                        :value="item.regionCode">
                                    </el-option>
                                  </el-select>
                                </el-form-item>
                              </el-col>
                              <el-col :span="8">
                                <el-form-item  prop="city" label-width="0px">
                                  <el-select v-model="agedDialog.form.city" placeholder="市" @change="getCountys" clearable>
                                    <el-option
                                        v-for="item in citys"
                                        :key="item.id"
                                        :label="item.regionName"
                                        :value="item.regionCode">
                                    </el-option>
                                  </el-select>
                                </el-form-item>
                              </el-col>
                              <el-col :span="8">
                                <el-form-item  prop="county" label-width="0px">
                                  <el-select v-model="agedDialog.form.county" placeholder="县" @change="getAreas" clearable>
                                    <el-option
                                        v-for="item in countys"
                                        :key="item.id"
                                        :label="item.regionName"
                                        :value="item.regionCode">
                                    </el-option>
                                  </el-select>
                                </el-form-item>
                              </el-col>
                              <el-col :span="8">
                                <el-form-item  prop="area" >
                                  <el-select v-model="agedDialog.form.area" placeholder="区" @change="getStreets" clearable>
                                    <el-option
                                        v-for="item in areas"
                                        :key="item.id"
                                        :label="item.regionName"
                                        :value="item.regionCode">
                                    </el-option>
                                  </el-select>
                                </el-form-item>
                              </el-col>
                              <el-col :span="8">
                                <el-form-item  prop="street" label-width="0px">
                                  <el-select v-model="agedDialog.form.street" placeholder="街道"  clearable>
                                    <el-option
                                        v-for="item in streets"
                                        :key="item.id"
                                        :label="item.regionName"
                                        :value="item.regionCode">
                                    </el-option>
                                  </el-select>
                                </el-form-item>
                              </el-col>
                            </el-row>

                            <el-row :gutter="20">
                              <el-col :span="24">
                                <el-form-item label="地址" prop="location">
                                  <el-input v-model="agedDialog.form.location"
                                            placeholder="请输入地址"></el-input>
                                </el-form-item>
                              </el-col>
                            </el-row>

                            <el-row :gutter="20">
                              <el-col :span="24">
                                <el-form-item label="注意事项">
                                  <el-input
                                      type="textarea"
                                      :rows="6"
                                      placeholder="请输入服务注意事项"
                                      v-model="agedDialog.form.notices">
                                  </el-input>
                                </el-form-item>
                              </el-col>
                            </el-row>

                          </div>


                          <div style="margin-top: 60px">
                            <el-row :gutter="20" type="flex" align="middle">
                              <el-col v-if="agedDialog.form.relatives.length > 0" :span="24">
                                <div v-for="(member, index) in agedDialog.form.relatives"
                                     class="family-member-row">
                                  <el-row type="flex" justify="center">
                                    <el-col :span="11">
                                      <el-row>
                                        <!--                                                                <el-col :span="19">-->
                                        <!--                                                                    <el-form-item label="姓名"-->
                                        <!--                                                                                  :rules="{required: true, message: '请输入亲属姓名',trigger:'blur'}"-->
                                        <!--                                                                                  :prop="'relatives['+index+'].name'">-->
                                        <!--                                                                        <el-input v-model="member.name"-->
                                        <!--                                                                                  placeholder="请输入亲属姓名"></el-input>-->
                                        <!--                                                                    </el-form-item>-->
                                        <!--                                                                </el-col>-->
                                        <el-col :span="19">
                                          <el-form-item label="姓名"
                                                        :prop="'relatives['+index+'].name'">
                                            <el-input v-model="member.name"
                                                      placeholder="请输入亲属姓名"></el-input>
                                          </el-form-item>
                                        </el-col>
                                        <el-col :span="5">
                                          <el-form-item label-width="0px"
                                                        :prop="'relatives['+index+'].relationship'">
                                            <el-select v-model="member.relationship"
                                                       placeholder="请选择亲属关系" clearable>
                                              <el-option label="父母"
                                                         value="PARENTS"></el-option>
                                              <el-option label="子女"
                                                         value="CHILDREN"></el-option>
                                              <el-option label="配偶"
                                                         value="COUPLE"></el-option>
                                              <el-option label="其他亲属"
                                                         value="RELATIVE"></el-option>
                                              <el-option label="护工"
                                                         value="WORKER"></el-option>
                                              <el-option label="其他"
                                                         value="OTHER"></el-option>
                                            </el-select>
                                          </el-form-item>
                                        </el-col>
                                      </el-row>
                                    </el-col>
                                    <el-col :span="11" :offset="1">
                                      <el-form-item label="监护人"
                                                    :prop="'relatives['+index+'].isGuardian'">
                                        <el-select v-model="member.isGuardian"
                                                   placeholder="请选择是否是监护人">
                                          <el-option label="是" :value="true"></el-option>
                                          <el-option label="否" :value="false"></el-option>
                                        </el-select>
                                      </el-form-item>
                                    </el-col>
                                  </el-row>
                                  <el-row type="flex" justify="center">
                                    <el-col :span="11">
                                      <el-form-item label="身份证号">
                                        <el-input v-model="member.idCard"
                                                  placeholder="请输入亲属身份证号"></el-input>
                                      </el-form-item>
                                    </el-col>
                                    <el-col :span="11" :offset="1">
                                      <el-form-item label="联系方式"
                                                    :prop="'relatives['+index+'].phone'">
                                        <el-input v-model="member.phone"
                                                  placeholder="请输入亲属电话"></el-input>
                                      </el-form-item>
                                    </el-col>
                                  </el-row>
                                  <el-row type="flex" justify="center">
                                    <el-col :span="23">
                                      <el-form-item label="地址">
                                        <el-input v-model="member.location"
                                                  placeholder="请输入地址"></el-input>
                                      </el-form-item>
                                    </el-col>
                                  </el-row>
                                  <el-row type="flex" justify="center">
                                    <el-col :span="24" style="text-align: center">
                                      <el-button type="danger" @click="removeFamilyMember(index)"
                                                 icon="el-icon-close"></el-button>
                                      <el-button
                                          v-if="index == agedDialog.form.relatives.length - 1"
                                          @click="addFamilyMember"
                                          type="primary" icon="el-icon-plus"></el-button>
                                    </el-col>
                                  </el-row>
                                </div>
                              </el-col>
                              <el-col v-else :span="24"
                                      style="text-align: center;height: 220px;line-height: 220px">
                                <el-button @click="addFamilyMember" type="primary" icon="el-icon-plus">
                                  添加亲属
                                </el-button>
                              </el-col>
                            </el-row>
                          </div>

                        </el-form>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </el-scrollbar>
            </div>
            <div style="float:right">
              <el-button @click="HomeVisible = false">取 消</el-button>
              <el-button type="primary" @click="handleUpdate">保存信息</el-button>
            </div>


          </el-tab-pane>
          <el-tab-pane label="现场改造" name="second">
            <div class="dialog-page" :style="{'height':($store.state.minPageHeight - 300) +'px'}">
              <el-scrollbar style="height: 100%">
                <div style="padding-right: 10px">
                  <el-form ref="detailsDialogForm" :model="detailsDialog.form" :rules="detailsDialog.rules" label-width="120px" size="small">
                    <el-row>
                      <el-col :span="24">
                        <div class="clearfix" style="border-bottom: 0px">
                          <span class="card-label">&nbsp;&nbsp;长者信息</span>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row class="form-area">
                      <el-col :span="24">
                        <el-row :gutter="20">
                          <el-col :span="12">
                            <el-form-item label="姓名">
                              <el-input v-model="detailsDialog.form.agedName" placeholder="姓名" ></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>

                        <el-row :gutter="20">
                          <el-col :span="12">
                            <el-form-item label="身份证号">
                              <el-input v-model="detailsDialog.form.idCard" placeholder="请输入身份证号" ></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="联系方式">
                              <el-input v-model="detailsDialog.form.agedPhone" placeholder="请输入联系方式" ></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="服务地址" prop="location">
                              <el-input placeholder="请输入服务地址" v-model="detailsDialog.form.location" ></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>

                    <el-row>
                      <el-col :span="24">
                        <div class="clearfix" style="border-bottom: 0px">
                          <span class="card-label">&nbsp;&nbsp;服务项目</span>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row :gutter="20">
                      <el-col :span="6">
                        <el-form-item label="网关">
                          <el-input v-model="detailsDialog.form.wangg" placeholder="请输入数量" ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="SOS">
                          <el-input v-model="detailsDialog.form.sos" placeholder="请输入数量" ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="红外">
                          <el-input v-model="detailsDialog.form.hongw" placeholder="请输入数量" ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="门磁">
                          <el-input v-model="detailsDialog.form.menc" placeholder="请输入数量" ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="20">
                      <el-col :span="6">
                        <el-form-item label="燃气">
                          <el-input v-model="detailsDialog.form.ranq" placeholder="请输入数量" ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="烟感">
                          <el-input v-model="detailsDialog.form.yang" placeholder="请输入数量" ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="水浸">
                          <el-input v-model="detailsDialog.form.shuij" placeholder="请输入数量" ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="防滑垫">
                          <el-input v-model="detailsDialog.form.fangh" placeholder="请输入数量" ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="20">
                      <el-col :span="6">
                        <el-form-item label="护理床">
                          <el-input v-model="detailsDialog.form.hulic" placeholder="请输入数量" ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="床边">
                          <el-input v-model="detailsDialog.form.chuangb" placeholder="请输入数量" ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="扶手">
                          <el-input v-model="detailsDialog.form.fus" placeholder="请输入数量" ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="沐浴椅">
                          <el-input v-model="detailsDialog.form.muyuy" placeholder="请输入数量" ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="20">
                      <el-col :span="6">
                        <el-form-item label="手杖">
                          <el-input v-model="detailsDialog.form.shouz" placeholder="请输入数量" ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="轮椅">
                          <el-input v-model="detailsDialog.form.luny" placeholder="请输入数量" ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="助行器">
                          <el-input v-model="detailsDialog.form.zhuxq" placeholder="请输入数量" ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="床带">
                          <el-input v-model="detailsDialog.form.chuangd" placeholder="请输入数量" ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="20">
                      <el-col :span="6">
                        <el-form-item label="摄像头">
                          <el-input v-model="detailsDialog.form.shexiangt" placeholder="请输入数量" ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="小夜灯">
                          <el-input v-model="detailsDialog.form.xiaoyed" placeholder="请输入数量" ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="手环">
                          <el-input v-model="detailsDialog.form.shouhuan" placeholder="请输入数量" ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="高差处理">
                          <el-input v-model="detailsDialog.form.gaocha" placeholder="请输入数量" ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row>
                      <el-col :span="24">
                        <div class="clearfix" style="border-bottom: 0px">
                          <span class="card-label">&nbsp;&nbsp;修改原因</span>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row class="form-area">
                      <el-col :span="24">
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="原因" prop="updateReason">
                              <el-input
                                  type="textarea"
                                  :rows="6"
                                  placeholder="请输入修改原因"
                                  v-model="detailsDialog.form.updateReason"
                              >
                              </el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>

                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="家庭养老床位建设验收单">
                              <template v-for="file in detailsDialog.form.xmqrsFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.xmqrsFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->
                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="xmqrsUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>




                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="防滑处理前">
                              <template v-for="file in detailsDialog.form.aaFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.aaFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="aaUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="防滑处理后">
                              <template v-for="file in detailsDialog.form.bbFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.bbFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="bbUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="高差处理前">
                              <template v-for="file in detailsDialog.form.ccFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.ccFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="ccUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="高差处理后">
                              <template v-for="file in detailsDialog.form.ddFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.ddFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="ddUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="配置护理床前">
                              <template v-for="file in detailsDialog.form.eeFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.eeFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="eeUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="配置护理床后">
                              <template v-for="file in detailsDialog.form.ffFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.ffFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="ffUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="安装床边前">
                              <template v-for="file in detailsDialog.form.ggFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.ggFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="ggUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="安装床边后">
                              <template v-for="file in detailsDialog.form.hhFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.hhFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="hhUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="安装扶手前">
                              <template v-for="file in detailsDialog.form.iiFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.iiFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="iiUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="安装扶手后">
                              <template v-for="file in detailsDialog.form.jjFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.jjFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="jjUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="配置淋浴椅前">
                              <template v-for="file in detailsDialog.form.kkFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.kkFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="kkUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="配置淋浴椅后">
                              <template v-for="file in detailsDialog.form.llFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.llFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="llUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="手杖前">
                              <template v-for="file in detailsDialog.form.mmFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.mmFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="mmUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="手杖后">
                              <template v-for="file in detailsDialog.form.nnFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.nnFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="nnUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="轮椅前">
                              <template v-for="file in detailsDialog.form.ooFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.ooFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="ooUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="轮椅后">
                              <template v-for="file in detailsDialog.form.ppFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.ppFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="ppUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="助行器前">
                              <template v-for="file in detailsDialog.form.qqFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.qqFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="qqUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="助行器后">
                              <template v-for="file in detailsDialog.form.rrFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.rrFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="rrUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="智能网关前">
                              <template v-for="file in detailsDialog.form.ssFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.ssFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="ssUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="智能网关后">
                              <template v-for="file in detailsDialog.form.ttFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.ttFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="ttUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>


                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="无线紧急呼叫设备前">
                              <template v-for="file in detailsDialog.form.uuFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.uuFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="uuUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="无线紧急呼叫设备后">
                              <template v-for="file in detailsDialog.form.vvFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.vvFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="vvUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="烟雾报警器前">
                              <template v-for="file in detailsDialog.form.wwFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.wwFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="wwUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="烟雾报警器后">
                              <template v-for="file in detailsDialog.form.xxFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.xxFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="xxUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="燃气报警器前">
                              <template v-for="file in detailsDialog.form.yyFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.yyFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="yyUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>


                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="燃气报警器后">
                              <template v-for="file in detailsDialog.form.zzFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.zzFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="zzUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="睡眠监测设备前">
                              <template v-for="file in detailsDialog.form.aaaFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.aaaFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="aaaUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="睡眠监测设备后">
                              <template v-for="file in detailsDialog.form.abbFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.abbFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="abbUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="安装自动感应灯具前">
                              <template v-for="file in detailsDialog.form.accFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.accFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="accUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="安装自动感应灯具后">
                              <template v-for="file in detailsDialog.form.addFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.addFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="addUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>


                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="门磁感应器前">
                              <template v-for="file in detailsDialog.form.aeeFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.aeeFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="aeeUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="门磁感应器后">
                              <template v-for="file in detailsDialog.form.affFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.affFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="affUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="语音或视频通话设备前">
                              <template v-for="file in detailsDialog.form.aggFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.aggFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="aggUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="语音或视频通话设备后">
                              <template v-for="file in detailsDialog.form.ahhFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.ahhFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="ahhUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="防走失装置前">
                              <template v-for="file in detailsDialog.form.aiiFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.aiiFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="aiiUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="防走失装置后">
                              <template v-for="file in detailsDialog.form.hFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.hFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="houUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>


                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="红外改造前">
                              <template v-for="file in detailsDialog.form.ajjFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.ajjFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="ajjUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="红外改造后">
                              <template v-for="file in detailsDialog.form.akkFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.akkFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="akkUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="水浸改造前">
                              <template v-for="file in detailsDialog.form.allFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.allFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="allUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :span="24">
                            <el-form-item label="水浸改造后">
                              <template v-for="file in detailsDialog.form.ammFiles">
                                <div class="img-line">
                                  <el-image v-if="file.fileId"
                                            style="width: 150px; height: 150px"
                                            :src="ip+file.filePath"
                                            :preview-src-list="allFile(detailsDialog.form.ammFiles)"
                                            fit="cover">
                                  </el-image>
                                  <!--                                  <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>-->

                                </div>
                              </template>
                              <el-upload
                                  class="avatar-uploader el-image"
                                  action="/system-ya/file/upload/picture"
                                  :show-file-list="false"
                                  :on-success="ammUpload">
                                <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>

                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </el-scrollbar>
            </div>
            <!--                        <div style="float:right">-->
            <!--                            <el-button @click="HomeVisible = false">取 消</el-button>-->
            <!--                            <el-button type="primary" @click="handleUpdWo">保 存</el-button>-->
            <!--                        </div>-->

          </el-tab-pane>
          <el-tab-pane label="告警信息" name="third">
            <el-row :gutter="20" class="out-border">
              <el-col :span="24">
                <div class="page-content">
                  <div>
                    <el-table :data="NBiotEventTable.data" highlight-current-row>
                      <el-table-column prop="agedName" label="告警老人"></el-table-column>
                      <el-table-column prop="status" label="状态">
                        <template scope="scope">
                          <span v-if="scope.row.status==='报警'" style="color: green">已处理（报警）</span>
                          <span v-if="scope.row.status==='测试'" style="color: green">已处理（测试）</span>
                          <span v-if="scope.row.status==='误报'" style="color: green">已处理（误报）</span>
                          <span v-if="scope.row.status==='演练'" style="color: green">已处理（演练）</span>
                          <span v-if="scope.row.status==='告警'" style="color: red">发生告警</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="type" label="设备类型">
                        <template scope="scope">
                          <span v-if="scope.row.type==='SOS'" >SOS告警</span>
                          <span v-if="scope.row.type==='GAS'" >燃气告警</span>
                          <span v-if="scope.row.type==='WATER'" >水浸告警</span>
                          <span v-if="scope.row.type==='Smoke'" >烟雾告警</span>
                          <span v-if="scope.row.type==='Infrared'" >红外告警</span>
                          <span v-if="scope.row.type==='DOOR'" >门磁告警</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="textAged" label="处理人"></el-table-column>
                      <el-table-column prop="createTime" label="告警时间"></el-table-column>
                      <el-table-column prop="content" label="告警信息"></el-table-column>
                      <el-table-column prop="textRead" label="处理方式"></el-table-column>
                      <el-table-column prop="textText" label="处理结果"></el-table-column>
                      <el-table-column label="操作">
                        <template slot-scope="scope" >
                          <el-button size="mini" type="text" @click="handleNBiotEdit(scope.row.id)">处理</el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div class="pagination">
                    <el-pagination
                        @current-change="handleCurrentChange"
                        @size-change="NBiotEventTable"
                        :current-page.sync="NBiotEventTable.page.currentPage"
                        :page-sizes="[10, 50, 100]"
                        :page-size.sync="NBiotEventTable.page.pageSize"
                        layout="sizes,  prev, pager, next, total"
                        :total="NBiotEventTable.page.total">
                    </el-pagination>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </template>


    </el-dialog>





  </div>
</template>

<script>
import {
  detailsWoDialogHOME,
  getAgedTableHOME,
  getDataQtyHOME, getDataQtyHOMEOld,
  getNBiotEventAgedTableHOME, getNBiotEventTableHOME,
  getPlatfromNameHOME, handleNBiotEditHOME, handleUpdHOME,
  loadEventsHOME, getRadarStatusHOME
} from "@/api/home-new";
import result from "element-ui/packages/result";
import {getGetProvinces, getHandleLoadData, getNextLevel} from "@/api/aged/aged_record";
import router from "@/router";

// 长者色系：青瓷、黛蓝、赭石、藕荷、松绿、砚灰
const SPOT_HUES = [
  {base: '#3f9a8c', deep: '#0f3b3a', glow: '#63c2b1'},
  {base: '#5476b0', deep: '#172a4d', glow: '#86a6db'},
  {base: '#b8773f', deep: '#3a2616', glow: '#e0a26a'},
  {base: '#a06a92', deep: '#33203a', glow: '#cf98c0'},
  {base: '#6b9a52', deep: '#1e3522', glow: '#9cc783'},
  {base: '#6f8595', deep: '#1f2c35', glow: '#9fb4c3'},
];

// 半身剪影的发型，viewBox 160×160；back 画在脸后面，front 盖在脸上
const ring = (x, y, r) => 'M' + (x - r) + ' ' + y + 'a' + r + ' ' + r + ' 0 1 0 ' + (2 * r) + ' 0a' + r + ' ' + r + ' 0 1 0 ' + (-2 * r) + ' 0Z';
const FIGURES = {
  male: [
    // 平头
    {front: 'M55 64C53 42 64 34 80 34C96 34 107 42 105 64C102 54 96 48 80 48C64 48 58 54 55 64Z'},
    // 侧分
    {front: 'M55 66C51 42 64 32 82 32C99 33 109 44 105 66C103 56 99 50 94 47C84 52 70 52 58 56C56 59 55 62 55 66Z'},
    // 谢顶，只剩两鬓
    {front: 'M56 76C53 64 54 56 59 50C60 58 61 66 62 74ZM104 76C107 64 106 56 101 50C100 58 99 66 98 74Z'},
    // 鸭舌帽
    {
      front: 'M57 74C55 66 55 62 56 58L62 60C61 64 61 68 62 72ZM103 74C105 66 105 62 104 58L98 60C99 64 99 68 98 72Z',
      cap: 'M54 58C54 38 66 30 80 30C96 30 106 38 106 56C98 52 66 52 54 58Z',
      brim: 'M52 57C68 50 94 50 111 55L112 61C94 57 68 57 52 63Z',
    },
  ],
  female: [
    // 短卷发
    {front: [[58, 58, 10], [65, 45, 11], [80, 39, 12], [95, 45, 11], [102, 58, 10], [55, 72, 8], [105, 72, 8]].map(c => ring(c[0], c[1], c[2])).join('')},
    // 盘发
    {
      back: ring(80, 31, 13),
      front: 'M54 66C52 44 64 36 80 36C96 36 108 44 106 66C102 54 94 48 80 48C66 48 58 54 54 66Z',
    },
    // 齐耳短发
    {
      back: 'M50 90C44 52 60 34 80 34C100 34 116 52 110 90C104 94 98 92 98 86L62 86C62 92 56 94 50 90Z',
      front: 'M56 62C57 44 70 38 82 38C96 38 104 46 104 60C92 51 72 50 56 62Z',
      noEars: true,
    },
    // 发箍短发
    {
      back: 'M52 80C46 50 62 36 80 36C98 36 114 50 108 80C104 82 102 78 102 74L58 74C58 78 56 82 52 80Z',
      front: 'M55 62C56 46 68 40 80 40C92 40 104 46 105 62C98 54 90 52 80 52C70 52 62 54 55 62Z',
      band: 'M55 56C60 42 70 37 80 37C90 37 100 42 105 56L102 58C97 46 89 42 80 42C71 42 63 46 58 58Z',
      noEars: true,
    },
  ],
};

// 首页设备分组：按顺序匹配，网关型 SOS 归入 SOS；网关本身只在 NB 设备清单里出现
const DEVICE_GROUPS = [
  {key: 'mattress', label: '睡眠带', icon: 'el-icon-moon-night', match: device => device.kind === 'mattress'},
  {key: 'radar', label: '睡眠雷达', icon: 'el-icon-aim', match: device => device.kind === 'radar'},
  {key: 'sos', label: 'SOS', icon: 'el-icon-bell', match: device => /SOS/i.test(device.type)},
  {key: 'door', label: '门磁', icon: 'el-icon-key', match: device => /门磁/.test(device.type)},
  {key: 'smoke', label: '烟感', icon: 'el-icon-cloudy', match: device => /烟感/.test(device.type)},
  {key: 'infrared', label: '红外', icon: 'el-icon-view', match: device => /红外/.test(device.type)},
  {key: 'gas', label: '燃气', icon: 'el-icon-hot-water', match: device => /燃气/.test(device.type)},
  {key: 'water', label: '水浸', icon: 'el-icon-heavy-rain', match: device => /水浸/.test(device.type)},
  {key: 'gateway', label: '网关', icon: 'el-icon-connection', match: device => /网关/.test(device.type), hidden: true},
  {key: 'other', label: '其他', icon: 'el-icon-cpu', match: () => true},
];
const RADAR_SLEEP = {'0': '深睡', '1': '浅睡', '2': '清醒', '3': '--'};
const RADAR_BREATH = {'1': '正常', '2': '呼吸过快', '3': '呼吸过低', '4': '--'};
const RADAR_MOVE = {'0': '--', '1': '静止', '2': '活跃'};

export default {
  name: "home-new",
  data: function () {
    return {
      ip:'/system-ya',
      HomeVisibleAged:true,
      HomeVisibleTitle:"老人档案",
      activeName: 'first',
      HomeVisible:false,
      agedId:"",
      SOS:'150',
      i:'0',
      events:[],
      spotIndex:0,
      spotAuto:true,
      spotHover:false,
      spotTick:0,
      spotInterval:8000,
      spotDir:1,
      spotPrev:0,
      brokenIcons:{},
      deviceDialog:{
        visible: false,
        title: '',
        kind: '',
        groupKey: '',
        devices: [],
      },
      // 睡眠雷达实时数据，按 imei 缓存本次弹窗的请求结果
      radarLiveMap:{},
      agedHealthTable:{
        condition: {
          "info":'',
          "agedName":'',
          "agedSex":'',
          "idCard":'',
          "location":'',
          "phone":'',

        },
        page: {
          "currentPage": 1,
          "pageSize": 12,
          "total": 0
        },
        data: [],
      },
      DataQty:{
        water:'',
        sos:'',
        gas:'',
        smoke:'',
        infrared:'',
        door:'',
        wuoc:'',
      },
      DataQtyOld:{
        water:'',
        sos:'',
        gas:'',
        smoke:'',
        infrared:'',
        door:'',
        wuoc:'',
      },
      NBiotEventTable: {
        condition: {
          "type": "",
        },
        page: {
          "currentPage": 1,
          "pageSize": 10,
          "total": 0
        },
        data: []
      },
      NBiotEventTableVisible:false,
      NBiotEventTableTitle:'告警信息',
      NBiotDialogVisible:false,
      NBiotDialogTitle:'处理',
      NBiotEventInfo:{
        id:'',
        type:'',
        agedId:'',
        agedName:'',
        createTime:'',
        project:'',
        content:'',
        status:'',
        textAged:'',
        textRead:'',
        textText:'',
        code:'',
        familyId:'',
        deviceId:'',
        deviceType:'',
        alarmStatus:'',
        priority:'',
        seatId:'',
        startTime:'',
        endTime:'',
        behaviorException:'',
        workOrders:'',

      },
      dataName:[],
      reportDialog:{
        visible: false,
        title: '日报',
        data:{

        },
        message:{}
      },
      agedHome:'',
      CDaiPage:'',

      agedDialog: {
        mode: 1,
        visible: false,
        title: '新的长者',
        form: {
          id: '',
          icon: '',
          remove:'',
          familyId: '',
          projectId:'',
          serviceOffer:'',
          idCard: '',
          cardType: 'ID_CARD',
          agedName: '',
          agedSex: 1,
          birthday: '',
          birthDateType: 1,
          phone: '',
          salesAmount:'',
          reformAmount:'',
          isLocal: true,
          subsidyStandard: '',
          agedSource: 'SOCIETY',
          callbackSupport: true,
          agedType: '',
          serviceStatus: 'NORMAL',
          notices: '',
          followNotes:'',
          location: '',
          address: '',
          lng: '',
          lat: '',
          relatives: [{
            id: '',
            name: '',
            phone: '',
            idCard: '',
            relationship: '',
            isGuardian: true,
            location: ''
          }],
          nickName: '',
          marriageStatus: '',
          politicalOutlook: '',
          bloodType: '',
          nation: '',
          religious: '',
          education: '',
          population: 1,
          holdType: '',
          offerStandard: '',
          offerType: '',
          hobby: '',
          permanentAddress: '',
          province:'',
          city:'',
          county:'',
          area:'',
          street:'',
          xiaoxinhuan:''
        },
        rules: {
          // idCard: [
          //     {required: true, message: '证件号不能为空', trigger: 'blur'},
          //     { min: 18, max: 18, message: '请输入有效身份证号', trigger: 'blur' }
          // ],
          // agedName: [
          //     {required: true, message: '长者姓名不能为空', trigger: 'blur'}
          // ],
          // phone: [
          //     {required: true, message: '联系电话不能为空', trigger: 'blur'},
          //     { min: 11, max:11, message: '请输入有效手机号码', trigger: 'blur' }
          // ],
          // serviceOffer:[
          //     { required: true, message: '请选择服务商', trigger: 'blur'}
          // ],
          // projectId:[
          //     { required: true, message: '请选择所属项目', trigger: 'blur'}
          // ],
          // location: [
          //     {required: true, message: '地址不能为空', trigger: 'blur'}
          // ],
          // province:[
          //     { required: true, message: '请输入服务地址', trigger: 'blur'}
          // ],
          // city:[
          //     { required: true, message: '请输入服务地址', trigger: 'blur'}
          // ],
          // county:[
          //     { required: true, message: '请输入服务地址', trigger: 'blur'}
          // ],
          // area:[
          //     { required: true, message: '请输入服务地址', trigger: 'blur'}
          // ],
          // street:[
          //     { required: true, message: '请输入服务地址', trigger: 'blur'}
          // ],
          // location:[
          //     { required: true, message: '请输入服务地址', trigger: 'blur'}
          // ],
        }
      },
      citys:[],
      countys:[],

      detailsDialog: {
        visible: false,
        title: '详情',
        form: {
          id: '',
          agedId: '',
          agedName:'',
          idCard: '',
          agedPhone: '',
          location: '',
          agedFamilyId:'',
          agedFamilyName:'',
          servicePerson:'',
          woType: '',
          notices: '',
          serviceOffer: '',
          servicePersonId: '',
          name:'',
          serviceType: '',
          serviceCycle: '',
          planStartTime: '',
          planEndTime: '',
          workOrderContentId: '',
          serviceContent: '',
          woSource: '',
          unitPrice: '',
          priceMode: '',
          updateReason: '',
          workOrderContent:'',
          remarks:'',
          files:[],
          cFiles:[],
          wFiles:[],
          kFiles:[],
          qFiles:[],
          hFiles:[],
          qrsFiles:[],
          aaFiles:[],
          bbFiles:[],
          ccFiles:[],
          ddFiles:[],
          eeFiles:[],
          ffFiles:[],
          ggFiles:[],
          hhFiles:[],
          iiFiles:[],
          jjFiles:[],
          kkFiles:[],
          llFiles:[],
          mmFiles:[],
          nnFiles:[],
          ooFiles:[],
          ppFiles:[],
          qqFiles:[],
          rrFiles:[],
          ssFiles:[],
          ttFiles:[],

          uuFiles:[],
          vvFiles:[],
          wwFiles:[],
          xxFiles:[],
          yyFiles:[],
          zzFiles:[],
          aaaFiles:[],
          abbFiles:[],
          accFiles:[],
          addFiles:[],
          aeeFiles:[],
          affFiles:[],
          aggFiles:[],
          ahhFiles:[],
          aiiFiles:[],

          ajjFiles:[],
          akkFiles:[],
          allFiles:[],
          ammFiles:[],
          annFiles:[],
          aooFiles:[],
          appFiles:[],
          aqqFiles:[],
          examineCivil:'',
          examineProject:'',

          wangg:'',
          sos:'',
          hongw:'',
          menc:'',
          ranq:'',
          yang:'',
          shuij:'',
          fangh:'',
          hulic:'',
          chuangb:'',
          fus:'',
          muyuy:'',
          shouz:'',
          luny:'',
          zhuxq:'',
          chuangd:'',
          shexiangt:'',
          xiaoyed:'',
          shouhuan:'',
          gaocha:'',
        },
      },

    }
  },
  computed: {
    layoutHeight(){
      let pageHeight = Number(this.$store.state.minPageHeight) || 0;
      return Math.max(pageHeight - 50, 660);
    },
    alarmTotal(){
      return (this.DataQty.gaoJinSl || []).reduce((sum, value) => sum + (Number(value) || 0), 0);
    },
    // 聚光灯当前展示的长者
    spot(){
      let list = this.agedHealthTable.data || [];
      return list[this.spotIndex] || list[0] || {};
    },
    spotFigure(){
      return this.photoOf(this.spot) ? null : this.figureOf(this.spot);
    },
    spotAge(){
      let age = Number(this.spot.agedAge);
      return age > 0 && age < 130 ? age : null;
    },
    spotAbility(){
      return this.abilityOf(this.spot.agedAbility);
    },
    spotDevices(){
      return this.deviceGroups(this.spot.homeDevices);
    },
    // 从实时告警里挑出该长者的记录
    spotEvents(){
      let id = this.spot.id;
      if(!id){
        return [];
      }
      return (this.events || []).filter(event => event.agedId == id).slice(0, 5);
    },
  },
  mounted: function () {
    this.getAgedTable();
    // this.getPlatfromName();
    this.getDataQty();
    this.getDataQtyOld();
    this.loadEvents();
    // setInterval(() => {
    //     this.loadEvents();
    // }, 75000);
    window.addEventListener('resize', this.resizeChart);
  },
  beforeDestroy(){
    clearTimeout(this.spotTimer);
    window.removeEventListener('resize', this.resizeChart);
    if(this.deviceChart){
      this.deviceChart.dispose();
      this.deviceChart = null;
    }
  },
  methods: {

    searchAged(){
      this.agedHealthTable.page.currentPage = 1;
      this.getAgedTable();
    },

    resetAgedSearch(){
      this.agedHealthTable.condition.agedName = '';
      this.agedHealthTable.condition.idCard = '';
      this.agedHealthTable.condition.location = '';
      this.searchAged();
    },

    handleAgedSizeChange(size){
      this.agedHealthTable.page.pageSize = size;
      this.searchAged();
    },

    isAlarm(item){
      if(item.alarmCount != null){
        return Number(item.alarmCount) > 0;
      }
      return !!item.pageText && item.pageText.indexOf('有') === 0;
    },

    // "能力轻度受损(轻度失能)" -> 轻度失能；按关键词分出 good / mild / severe 三档配色
    abilityOf(text){
      let raw = String(text || '').trim();
      if(!raw){
        return null;
      }
      let inner = raw.match(/[(（]([^)）]+)[)）]/);
      let label = inner ? inner[1] : raw;
      if(label.length > 6){
        label = label.slice(0, 6) + '…';
      }
      let level = 'plain';
      if(/重度|完全|全护理/.test(raw)){
        level = 'severe';
      }else if(/轻度|中度|半失能/.test(raw)){
        level = 'mild';
      }else if(/完好|自理|独立/.test(raw)){
        level = 'good';
      }
      return {label: label, level: level};
    },

    deviceGroupOf(device){
      return DEVICE_GROUPS.find(group => group.match(device));
    },

    // 在用设备按类归组；state: online 全部在线 / partial 部分在线 / offline 全部离线
    deviceGroups(devices){
      let groups = [];
      (devices || []).forEach(device => {
        let def = this.deviceGroupOf(device);
        if(def.hidden){
          return;
        }
        let group = groups.find(item => item.key === def.key);
        if(!group){
          group = {key: def.key, label: def.label, icon: def.icon, devices: []};
          groups.push(group);
        }
        group.devices.push(device);
      });
      groups.sort((a, b) => DEVICE_GROUPS.findIndex(def => def.key === a.key) - DEVICE_GROUPS.findIndex(def => def.key === b.key));
      groups.forEach(group => {
        let online = group.devices.filter(device => device.online).length;
        let total = group.devices.length;
        group.state = online === total ? 'online' : (online ? 'partial' : 'offline');
        group.title = group.label + '：' + (total > 1 ? online + '/' + total + ' 台在线' : (online ? '在线' : '离线'))
            + (group.key === 'mattress' ? '，点击查看睡眠报告' : '，点击查看详情');
      });
      return groups;
    },

    openDeviceGroup(group){
      let spot = this.spot;
      if(group.key === 'mattress'){
        this.ceshi(spot.id);
        return;
      }
      if(group.key === 'radar'){
        this.deviceDialog = {visible: true, title: spot.agedName + ' · 睡眠雷达', kind: 'radar', groupKey: group.key, devices: group.devices};
        group.devices.forEach(radar => this.loadRadarLive(radar));
        return;
      }
      // NB-IoT：列出该长者全部 NB 设备（含网关），点击的那一类排在前面并高亮
      let nbDevices = (spot.homeDevices || []).filter(device => device.kind === 'nbiot');
      let rank = device => {
        let key = this.deviceGroupOf(device).key;
        return key === group.key ? 0 : (key === 'gateway' ? 1 : 2);
      };
      nbDevices = nbDevices.slice().sort((a, b) => rank(a) - rank(b));
      this.deviceDialog = {visible: true, title: spot.agedName + ' · NB-IoT 设备', kind: 'nbiot', groupKey: group.key, devices: nbDevices};
    },

    deviceRowClass({row}){
      return this.deviceGroupOf(row).key === this.deviceDialog.groupKey ? 'is-picked' : '';
    },

    deviceLastTime(device){
      if(device.lastTime){
        return device.lastTime;
      }
      // 网关下挂的子设备不单独上报心跳
      return /^(门磁|红外|烟感|燃气|SOS紧急按钮|水浸探测器)$/.test(device.type) ? '随网关' : '--';
    },

    loadRadarLive(radar){
      let imei = radar.deviceNo;
      if(!imei){
        this.$set(this.radarLiveMap, radar.id, {error: '未登记 IMEI，无法读取实时数据'});
        return;
      }
      this.$set(this.radarLiveMap, radar.id, {loading: true});
      getRadarStatusHOME(imei)
          .then(result => {
            if(result && result.data){
              this.$set(this.radarLiveMap, radar.id, {data: result.data});
            }else{
              this.$set(this.radarLiveMap, radar.id, {error: '暂无实时数据'});
            }
          })
          .catch(() => {
            this.$set(this.radarLiveMap, radar.id, {error: '实时数据读取失败，请稍后再试'});
          });
    },

    radarLive(radar){
      return this.radarLiveMap[radar.id] || {loading: true};
    },

    radarView(radar){
      let data = this.radarLive(radar).data || {};
      let heart = Number(data.heartRate);
      let breath = Number(data.breathRate);
      let present = data.hasPerson === '1' || heart > 1;
      return {
        present: present,
        sleep: RADAR_SLEEP[data.sleepStatus] && RADAR_SLEEP[data.sleepStatus] !== '--' ? RADAR_SLEEP[data.sleepStatus] : '状态未知',
        heart: present && heart > 0 ? heart : '--',
        breath: present && breath > 0 ? breath : '--',
        breathState: present ? (RADAR_BREATH[data.breathStatus] || '--') : '--',
        move: present ? (RADAR_MOVE[data.moveStatus] || '--') : '--',
      };
    },

    // 默认聚焦本页第一位有告警的长者，没有则第一位
    defaultSpotIndex(){
      let index = (this.agedHealthTable.data || []).findIndex(item => this.isAlarm(item));
      return index < 0 ? 0 : index;
    },

    selectSpot(index, dir){
      this.spotDir = dir || (index >= this.spotIndex ? 1 : -1);
      this.spotPrev = this.spotIndex;
      this.spotIndex = index;
      this.restartSpotTimer();
    },

    stepSpot(step){
      let length = (this.agedHealthTable.data || []).length;
      if(!length){
        return;
      }
      this.selectSpot((this.spotIndex + step + length) % length, step);
    },

    toggleSpotAuto(){
      this.spotAuto = !this.spotAuto;
      this.restartSpotTimer();
    },

    pauseSpot(){
      this.spotHover = true;
      clearTimeout(this.spotTimer);
    },

    resumeSpot(){
      this.spotHover = false;
      this.restartSpotTimer();
    },

    restartSpotTimer(){
      clearTimeout(this.spotTimer);
      this.spotTick++;
      if(!this.spotAuto || this.spotHover || !(this.agedHealthTable.data || []).length){
        return;
      }
      this.spotTimer = setTimeout(this.advanceSpot, this.spotInterval);
    },

    // 轮播到本页最后一位后自动翻到下一页，最后一页后回到第一页
    advanceSpot(){
      let length = (this.agedHealthTable.data || []).length;
      if(this.spotIndex < length - 1){
        this.selectSpot(this.spotIndex + 1, 1);
        return;
      }
      let page = this.agedHealthTable.page;
      let pageCount = Math.max(1, Math.ceil(page.total / page.pageSize));
      if(pageCount <= 1){
        this.selectSpot(0, 1);
        return;
      }
      this.spotAutoTurn = true;
      this.spotDir = 1;
      this.handleCurrentChange(page.currentPage >= pageCount ? 1 : page.currentPage + 1);
    },

    // 姓氏字标：取名字里第一个汉字，没有汉字取首字母，都没有取第一个字符
    monogram(name){
      let text = String(name || '').trim();
      let match = text.match(/[\u4e00-\u9fa5]|[A-Za-z]/);
      return (match ? match[0] : text.charAt(0) || '?').toUpperCase();
    },

    // 每位长者按 id 固定分到一个色系
    hashOf(item){
      let key = String(item.id || item.agedName || '');
      let sum = 0;
      for(let i = 0; i < key.length; i++){
        sum = (sum * 31 + key.charCodeAt(i)) % 9973;
      }
      return sum;
    },

    hueOf(item){
      return SPOT_HUES[this.hashOf(item) % SPOT_HUES.length];
    },

    hueStyle(item){
      let hue = this.hueOf(item);
      return {'--hue': hue.base, '--hue-deep': hue.deep, '--hue-glow': hue.glow};
    },

    // 无照片时的半身剪影：按性别取发型组，组内按 id 固定一款；性别不明返回 null，退回姓氏字
    figureOf(item){
      let sex = String(item.agedSex == null ? '' : item.agedSex);
      let group = sex === '女' || sex === '0' ? FIGURES.female : sex === '男' || sex === '1' ? FIGURES.male : null;
      if(!group){
        return null;
      }
      let figure = group[Math.floor(this.hashOf(item) / SPOT_HUES.length) % group.length];
      return Object.assign({female: group === FIGURES.female}, figure);
    },

    photoOf(item){
      return item.icon && !this.brokenIcons[item.icon] ? '/system-ya/file/image/' + item.icon : '';
    },

    iconBroken(icon){
      this.$set(this.brokenIcons, icon, true);
    },

    // 在环上的相对位置：当前长者为 0，左负右正
    coverOffset(index, center, length){
      let half = Math.floor(length / 2);
      return ((index - center) % length + length + half) % length - half;
    },

    // Cover Flow：两侧头像向中间转、缩小、变淡；绕到背面的那一个不做过渡，避免横穿整条
    coverStyle(index){
      let length = (this.agedHealthTable.data || []).length;
      let half = Math.floor(length / 2);
      let d = this.coverOffset(index, this.spotIndex, length);
      let prev = this.coverOffset(index, this.spotPrev, length);
      let abs = Math.abs(d);
      let reach = Math.min(half, 6);
      let first = 10;
      let step = reach > 1 ? Math.min(8, (45 - first) / (reach - 1)) : 0;
      let off = d === 0 ? 0 : Math.sign(d) * (first + (Math.min(abs, reach + 1) - 1) * step);
      return {
        left: 'calc(50% + ' + off.toFixed(2) + '%)',
        transform: d === 0 ? 'scale(1.18)' : 'rotateY(' + (d < 0 ? 42 : -42) + 'deg) scale(' + Math.max(0.74, 1 - abs * 0.05).toFixed(2) + ')',
        opacity: abs > reach ? 0 : Math.max(0.42, 1 - abs * 0.1),
        zIndex: 50 - abs,
        pointerEvents: abs > reach ? 'none' : '',
        transition: Math.abs(d - prev) > half ? 'none' : '',
      };
    },

    // 鼠标位置驱动卡片轻微倾斜，直接写 CSS 变量，不走响应式
    tiltSpot(event){
      let deck = event.currentTarget;
      let box = deck.getBoundingClientRect();
      let x = (event.clientX - box.left) / box.width - 0.5;
      let y = (event.clientY - box.top) / box.height - 0.5;
      deck.style.setProperty('--mx', x.toFixed(3));
      deck.style.setProperty('--my', y.toFixed(3));
    },

    untiltSpot(event){
      event.currentTarget.style.setProperty('--mx', 0);
      event.currentTarget.style.setProperty('--my', 0);
    },

    sleepBeltIcon(item){
      return item.cDaiPage || item.cdaiPage || item.CDaiPage;
    },

    // 拆分告警内容 "[林爷爷]紧急报警器被触发！..." -> 姓名 + 内容
    eventParts(content){
      let text = content || '';
      let match = text.match(/^\s*[\[【]([^\]】]+)[\]】]\s*(.*)$/);
      return match ? {name: match[1], text: match[2]} : {name: '', text: text};
    },

    // "2026-09-18 09:38:26" -> "09:38"
    eventClock(time){
      let match = String(time || '').match(/(\d{1,2}:\d{2})/);
      return match ? match[1] : '--:--';
    },

    // "2026-09-18 09:38:26" -> "今天" / "昨天" / "09-18"
    eventDay(time){
      let match = String(time || '').match(/(\d{4})-(\d{2})-(\d{2})/);
      if(!match){
        return '';
      }
      let day = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
      let today = new Date();
      today.setHours(0, 0, 0, 0);
      let diff = Math.round((today - day) / 86400000);
      if(diff === 0) return '今天';
      if(diff === 1) return '昨天';
      return match[2] + '-' + match[3];
    },

    eventLevel(content){
      let text = content || '';
      if(/紧急|SOS|烟|燃气|水浸|跌倒/i.test(text)) return 'danger';
      if(/离床|围栏|心率|呼吸|低电/.test(text)) return 'warning';
      return 'info';
    },

    resizeChart(){
      if(this.deviceChart){
        this.deviceChart.resize();
      }
    },


    choice(id){
      this.getProvinces();
      this.handleLoadData(id);
      this.getNBiotEventAgedTable(id);
      this.detailsWoDialog(id);

    },


    ceshi(id){
      this.HomeVisible=false;
      this.handleReport(id);
    },

    getAgedTable(){
      let me = this;
      let param = {};
      param.page = {
        currentPage:me.agedHealthTable.page.currentPage,
        pageSize:me.agedHealthTable.page.pageSize
      };
      param.condition = me.agedHealthTable.condition;
      getAgedTableHOME(param)
          .then(result=>{
            if(result.data){
              me.agedHealthTable.data = result.data.content || [];
              me.agedHealthTable.page.currentPage = result.data.page.currentPage;
              me.agedHealthTable.page.total = result.data.page.total;

              for(me.i = 0; me.i < me.agedHealthTable.data.length; me.i++){
                if(me.agedHealthTable.data[me.i].agedSex == "0"){
                  me.agedHealthTable.data[me.i].agedSex = "女";

                }else if(me.agedHealthTable.data[me.i].agedSex == 1){
                  me.agedHealthTable.data[me.i].agedSex = "男";

                }
              };
            }else{
              me.agedHealthTable.data = [];
              me.agedHealthTable.page.total = 0;
            }
            me.spotIndex = me.spotAutoTurn ? 0 : me.defaultSpotIndex();
            me.spotAutoTurn = false;
            me.spotPrev = me.spotIndex;
            me.restartSpotTimer();
          })
    },


    getPlatfromName:function () {
      let me = this;
      getPlatfromNameHOME()
          .then(result=>{
            me.dataName = result.data;
            if(me.dataName.bedName == null || me.dataName.bedName == ""){
              me.dataName.bedName = "家庭养老床位";
            }
          })
    },


    myChart(){
      let me = this;
      let el = document.getElementById('data_2');
      if(!el){
        return;
      }
      let names = me.DataQty.gaoJin || [];
      let values = me.DataQty.gaoJinSl || [];
      // 同名告警类型合并后按次数降序，便于直接看出高发类型
      let merged = {};
      names.forEach((name, index) => {
        let key = name || '未知';
        merged[key] = (merged[key] || 0) + (Number(values[index]) || 0);
      });
      let rows = Object.keys(merged).map(name => ({name: name, value: merged[name]}))
          .sort((a, b) => b.value - a.value);
      let visibleCount = 6;
      let scrollable = rows.length > visibleCount;

      if(!me.deviceChart){
        me.deviceChart = echarts.init(el);
      }
      let option = {
        grid: {
          left: 0,
          right: scrollable ? 22 : 10,
          top: 4,
          bottom: 4,
          containLabel: true,
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {type: 'shadow', shadowStyle: {color: 'rgba(255, 255, 255, 0.04)'}},
          backgroundColor: '#ffffff',
          borderWidth: 0,
          textStyle: {color: '#17313b', fontSize: 12},
          formatter: function (params) {
            let param = params[0];
            return `${param.name}<br/>告警次数：<b>${param.value}</b>`;
          }
        },
        dataZoom: scrollable ? [
          {
            type: 'slider',
            yAxisIndex: [0, 1],
            right: 0,
            width: 6,
            startValue: 0,
            endValue: visibleCount - 1,
            zoomLock: true,
            showDetail: false,
            showDataShadow: false,
            brushSelect: false,
            borderColor: 'transparent',
            backgroundColor: 'rgba(255, 255, 255, 0.06)',
            fillerColor: 'rgba(255, 255, 255, 0.22)',
            handleSize: 0,
            moveHandleSize: 0,
          },
          {
            type: 'inside',
            yAxisIndex: [0, 1],
            zoomOnMouseWheel: false,
            moveOnMouseWheel: true,
            moveOnMouseMove: false,
          },
        ] : [],
        xAxis: {
          type: 'value',
          show: false,
        },
        yAxis: [
          {
            type: 'category',
            inverse: true,
            data: rows.map(row => row.name),
            axisLine: {show: false},
            axisTick: {show: false},
            axisLabel: {
              color: '#b9d0d5',
              fontSize: 12,
              width: 84,
              overflow: 'truncate',
            },
          },
          {
            type: 'category',
            inverse: true,
            position: 'right',
            data: rows.map(row => row.value),
            axisLine: {show: false},
            axisTick: {show: false},
            axisLabel: {
              color: '#e8f1f2',
              fontSize: 13,
              fontFamily: 'Bahnschrift, "DIN Alternate", sans-serif',
            },
          },
        ],
        series: [
          {
            type: 'bar',
            data: rows.map((row, index) => ({
              value: row.value,
              itemStyle: {color: index === 0 ? '#f0a53a' : '#3fbfa9'},
            })),
            barWidth: 10,
            barMinHeight: 3,
            showBackground: true,
            backgroundStyle: {color: 'rgba(255, 255, 255, 0.06)', borderRadius: 5},
            itemStyle: {borderRadius: 5},
          }
        ],
      };

      me.deviceChart.setOption(option, true);
      me.deviceChart.resize();
    },

    loadEvents(){
      let me = this;
      me.events = null;
      loadEventsHOME()
          .then(result=>{
            if(result.data){
              me.events = result.data;
            }
          })
    },

    getDataQty(){
      let me = this;
      getDataQtyHOME()
          .then(result=>{
            if(result.data){
              me.DataQty = result.data;
              console.log(me.DataQty);
              me.myChart();
            }
          })
    },

    getDataQtyOld(){
      let me = this;
      getDataQtyHOMEOld()
          .then(result=>{
            if(result.data){
              me.DataQtyOld = result.data;
              me.DataQtyOld.wuoC = 0;
            }else {
              me.DataQtyOld.wuoC = 0;
              me.DataQtyOld.sos = 0;
              me.DataQtyOld.smoke = 0;
              me.DataQtyOld.water = 0;
              me.DataQtyOld.infrared = 0;
              me.DataQtyOld.door = 0;
              me.DataQtyOld.gas = 0;
            }
          })
    },

    getNBiotEventTable(){
      let me = this;
      let param = {};
      param.page = {
        currentPage:me.NBiotEventTable.page.currentPage,
        pageSize:me.NBiotEventTable.page.pageSize
      };
      param.condition = me.NBiotEventTable.condition;
      getNBiotEventTableHOME(param)
          .then(result=>{
            if(result.data){
              me.NBiotEventTable.data = result.data.content;
              me.NBiotEventTable.page.currentPage = result.data.page.currentPage;
              me.NBiotEventTable.page.total = result.data.page.total;
            }
          })
    },

    GetGJXX(id){
      this.NBiotEventTableVisible = true;
      this.getNBiotEventAgedTable(id);
    },

    //单个老人告警查询
    getNBiotEventAgedTable(id){
      let me = this;
      me.HomeVisible=false;
      let param = {};
      me.NBiotEventTable.condition.type = id;
      me.agedId = id;
      param.page = {
        currentPage:me.NBiotEventTable.page.currentPage,
        pageSize:me.NBiotEventTable.page.pageSize
      };
      param.condition = me.NBiotEventTable.condition;
      getNBiotEventAgedTableHOME(param)
          .then(result=>{
            if(result.data){
              me.NBiotEventTable.data = result.data.content;
              me.NBiotEventTable.page.currentPage = result.data.page.currentPage;
              me.NBiotEventTable.page.total = result.data.page.total;
            }
          })
    },



    //详情
    handleNBiotEdit:function (id) {
      let me =this;
      handleNBiotEditHOME(id)
          .then(result=>{
            let NBiotEventInfo = result.data;
            if(NBiotEventInfo){
              me.fillNBiotForm(NBiotEventInfo);
              // me.getNBiotOlder();
              me.NBiotEventTableVisible = false;
              me.NBiotDialogVisible = true;
            }
          })
    },


    fillNBiotForm:function (NBiotEventInfo) {
      let me = this;
      me.NBiotEventInfo = NBiotEventInfo;
      me.NBiotEventInfo.status = "报警";
    },

    //更新
    handleUpd(){
      let me = this;
      let param = this.NBiotEventInfo;
      handleUpdHOME(param)
          .then(result=>{
            if(result.data){
              me.$message.success("处理成功");
              me.NBiotDialogVisible = false;
              me.NBiotEventTableVisible = true;
              if(me.NBiotEventTable.condition.type == me.agedId){
                me.getNBiotEventAgedTable(me.agedId);
              }else {
                me.getNBiotEventTable();
              }
              me.getDataQty();
            }
          })
    },

    choiceSOS(){
      let me = this;
      me.NBiotEventTable.condition.type = "SOS";
      me.getNBiotEventTable();
      me.NBiotEventTableVisible = true

    },

    choiceGAS(){
      let me = this;
      me.NBiotEventTable.condition.type = "GAS";
      me.getNBiotEventTable();
      me.NBiotEventTableVisible = true
    },

    choiceWATER(){
      let me = this;
      me.NBiotEventTable.condition.type = "WATER";
      me.getNBiotEventTable();
      me.NBiotEventTableVisible = true
    },

    choiceSmoke(){
      let me = this;
      me.NBiotEventTable.condition.type = "Smoke";
      me.getNBiotEventTable();
      me.NBiotEventTableVisible = true
    },

    choiceInfrared(){
      let me = this;
      me.NBiotEventTable.condition.type = "Infrared";
      me.getNBiotEventTable();
      me.NBiotEventTableVisible = true
    },

    choiceDOOR(){
      let me = this;
      me.NBiotEventTable.condition.type = "DOOR";
      me.getNBiotEventTable();
      me.NBiotEventTableVisible = true
    },

    getNowData:function(createTime){
      // let me = this;
      let timestamp = (new Date()).getTime();
      let stringTime = createTime;
      let timestamp2 = Date.parse(new Date(stringTime));
      let judge = timestamp - timestamp2 <= 10000;
      return judge;

    },

    //详情
    lodWoTab:function () {
      let me =this;
      $.ajax({
        url: "/gongDanGuanLian/generate/",
        type: 'GET',
        dataType:"json",
        contentType: 'application/json;charset=UTF-8',
        success: function (result) {

        }
      });
    },

    //床带
    handleReport(id) {
      let me = this;
      $.ajax({
        url: "chuangdai/infoHome/"+id,
        type: 'GET',
        success: function (result) {
          if(result.data){
            me.reportDialog.visible = true;
            me.reportDialog.data = result.data.cdRes.data;
            me.reportDialog.message = result.data.message;
            // me.reportDialog.title = result.data.mark[0].date;
            me.$nextTick(()=>{
              me.initHxBar();
              me.initXlLine();
              // me.initsocket(result.data.serial)
            })
          }
        }
      });
    },

    //查询是否有床带
    handleReportAgedHome(id) {
      let me = this;
      $.ajax({
        url: "chuangdai/AgedHome/"+id,
        type: 'GET',
        success: function (result) {
          me.agedHome = result.data;
          if(me.agedHome == "0"){
            me.agedHealthTable.data[me.i].CDaiPage = "../static/asert/image/report/icon-1.3.4.png";
          }else if(me.agedHome == "1"){
            me.agedHealthTable.data[me.i].CDaiPage = "../static/asert/image/report/icon-1.3.4.png";
          }


        }
      });
    },


    initHxBar(){
      let me = this;
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById('hx-bar'));
      let option = {
        xAxis: {
          type: 'category',
          data: me.reportDialog.data.dt_arr
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: me.reportDialog.data.hx_arr,
            type: 'bar'
          }
        ]
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
    initXlLine(){
      let me = this;
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById('xl-line'));
      let option =  {
        xAxis: {
          type: 'category',
          data: me.reportDialog.data.dt_arr
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: me.reportDialog.data.rh_arr,
            type: 'line'
          }
        ]
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },


    handleLoadData(id) {
      if (!id) {
        return false;
      }
      let me = this;
      me.clearAgedForm();
      getHandleLoadData(id)
          .then(result=>{
            if (result.data) {
              me.agedDialog.form = result.data;
              me.agedDialog.mode = 2;
              me.HomeVisible = true;
              me.HomeTitle = "老人信息"
              if (!result.data.city){
                return;
              }else {
                //加载县
                me.getCounty(result.data.city);
              };
              if (!result.data.province){
                return;
              }else {
                //加载市
                me.getCity(result.data.province);
              };
              if (!result.data.county){
                return;
              }else {
                //加载区
                me.getArea(result.data.county);
              };
              if (!result.data.area){
                return;
              }else {
                //加载街道
                me.getStreet(result.data.area);
              };
            }
          })
    },

    clearAgedForm() {
      this.agedDialog.form = {
        id: '',
        icon: '',
        familyId: '',
        projectId:'',
        idCard: '',
        serviceOffer:'',
        cardType: 'ID_CARD',
        agedName: '',
        agedSex: 1,
        birthday: '',
        birthDateType: 1,
        phone: '',
        salesAmount:'',
        reformAmount:'',
        isLocal: true,
        subsidyStandard: '',
        agedSource: 'SOCIETY',
        callbackSupport: true,
        agedType: '',
        serviceStatus: 'NORMAL',
        notices: '',
        followNotes:'',
        location: '',
        'address': '',
        'lng': '',
        'lat': '',
        relatives: [{
          id: '',
          name: '',
          phone: '',
          idCard: '',
          relationship: '',
          isGuardian: true,
          location: ''
        }],
        nickName: '',
        marriageStatus: '',
        politicalOutlook: '',
        bloodType: '',
        nation: '',
        religious: '',
        education: '',
        population: 1,
        holdType: '',
        offerStandard: '',
        offerType: '',
        hobby: '',
        permanentAddress: '',
      }
    },

    //获取省
    getProvinces:function () {
      let me = this;
      getGetProvinces()
          .then(result=>{
            if(result.data){
              me.provinces = result.data;
            }
          })
    },
    getCitys:function (parentId) {
      this.agedDialog.form.city = '';
      this.agedDialog.form.county = '';
      this.agedDialog.form.area = '';
      this.agedDialog.form.street = '';
      this.healthTable.condition.city = '';
      this.healthTable.condition.county = '';
      this.healthTable.condition.area = '';
      this.healthTable.condition.street = '';
      this.clearCitys();
      if (!parentId){
        return;
      }else {
        let me = this;
        getNextLevel(parentId)
            .then(result=>{
              if(result.data){
                me.citys = result.data;
              }
            })
      }

    },
    getCity:function (parentId) {
      let me = this;
      me.citys = [];
      getNextLevel(parentId)
          .then(result=>{
            if(result.data){
              me.citys = result.data;
            }
          })
    },
    getCountys:function (parentId) {
      this.agedDialog.form.county = '';
      this.agedDialog.form.area = '';
      this.agedDialog.form.street = '';
      this.healthTable.condition.county = '';
      this.healthTable.condition.area = '';
      this.healthTable.condition.street = '';
      this.clearAreas();
      if (!parentId){
        return;
      }else {
        let me = this;
        getNextLevel(parentId)
            .then(result=>{
              if(result.data){
                me.countys = result.data;
              }
            })
      }
    },
    getCounty:function (parentId) {
      let me = this;
      me.countys = [];
      getNextLevel(parentId)
          .then(result=>{
            if(result.data){
              me.countys = result.data;
            }
          })
    },
    getAreas:function (parentId) {
      this.agedDialog.form.area = '';
      this.agedDialog.form.street = '';
      this.healthTable.condition.area = '';
      this.healthTable.condition.street = '';
      this.clearStreets();
      if (!parentId){
        return;
      }else {
        let me = this;
        getNextLevel(parentId)
            .then(result=>{
              if(result.data){
                me.areas = result.data;
              }
            })
      }
    },
    getArea:function (parentId) {
      let me = this;
      getNextLevel(parentId)
          .then(result=>{
            if(result.data){
              me.areas = result.data;
            }
          })
    },
    getStreets:function (parentId) {
      this.agedDialog.form.street = '';
      this.healthTable.condition.street = '';
      let me = this;
      getNextLevel(parentId)
          .then(result=>{
            if(result.data){
              me.streets = result.data;
            }
          })
    },
    getStreet:function (parentId) {
      let me = this;
      getNextLevel(parentId)
          .then(result=>{
            if(result.data){
              me.streets = result.data;
            }
          })
    },
    clearCitys:function () {
      let me = this;
      me.citys = [];
      me.clearCountys();
    },
    clearCountys:function () {
      let me = this;
      me.countys = [];
      me.clearAreas();
    },
    clearAreas:function () {
      let me = this;
      me.areas = [];
      me.clearStreets();
    },
    clearStreets:function () {
      let me = this;
      me.streets = [];
    },

    handleUpdate() {
      let me = this;
      this.$refs['aged-form'].validate((valid) => {
        if (valid) {
          let param = this.agedDialog.form;
          $.ajax({
            url: "aged/upd",
            type: 'POST',
            data: JSON.stringify(param),
            success: function (result) {
              me.$message.success("保存成功");
              me.closeAgedDialog();
            }
          });
        }
      });
    },

    closeAgedDialog() {
      this.HomeVisible = false;
      this.getAgedTable();
      this.clearAgedForm();
    },


    handleProviderChange(){
      this.detailsDialog.form.servicePersonId = '';
    },
    toggleSearchArea(){
      if(this.moreSearch){
        this.moreSearch = false;
      } else {
        this.moreSearch = true;
      }
    },
    loadOffers(){
      let me = this;
      $.ajax({
        url: "provider/list",
        type: 'POST',
        success: function (result) {
          if(result.data){
            me.offers = result.data;
          }
        }
      });
    },
    loadAgedFiles(id){
      let me = this;
      $.ajax({
        url: "constructionProgramme/"+id+"/files",
        type: 'POST',
        success: function (result) {
          if(result.data){
            me.files = result.data;
          }
        }
      });
    },
    allFile(files){
      return files.map((file)=>{
        return file.filePath
      });
    },
    loadWoTable(){
      let me = this;

      this.woTable.currentRow = '';
      this.buttonStatus = 0;

      let param = {};
      param.page = {
        currentPage:me.woTable.page.currentPage,
        pageSize:me.woTable.page.pageSize
      };
      param.condition = me.woTable.condition;

      $.ajax({
        url: "constructionProgramme/selectAllTable",
        type: 'POST',
        data:JSON.stringify(param),
        success: function (result) {
          if(result.data){
            me.woTable.data = result.data.content;
            me.woTable.page.currentPage = result.data.page.currentPage;
            me.woTable.page.total = result.data.page.total;

          }
        }
      });
    },
    loadEms(){
      let me = this;
      $.ajax({
        url: "em/list",
        type: 'POST',
        success: function (result) {
          if(result.data){
            me.servicePersons = result.data;
          }
        }
      });
    },
    loadProviderEms(){
      let me = this;
      if(!this.detailsDialog.form.serviceOffer && this.detailsDialog.form.serviceOffer !== 0){
        me.servicePersons = [];
        return;
      }
      $.ajax({
        url: "provider/em/list/" + this.detailsDialog.form.serviceOffer,
        type: 'POST',
        success: function (result) {
          if(result.data){
            me.servicePersons = result.data;
          } else {
            me.servicePersons = [];
          }
        }
      });
    },
    loadWorkOrderContents(){
      let me = this;
      $.ajax({
        url: "wo/content/list",
        type: 'POST',
        success: function (result) {
          if(result.data){
            me.workOrderContents = result.data;
          }
        }
      });
    },
    woSelectionChange(row, column){
      this.woTable.currentRow = row;
      this.buttonStatus = 0;
      switch (row.woStatus) {
        case 'CREATE':
          this.buttonStatus = 1;
          break;
        case 'APPROVE':
          this.buttonStatus = 2;
          break;
        case 'PUBLISH':
          this.buttonStatus = 3;
          break;
        case 'PROGRESS':
          this.buttonStatus = 4;
          break;
        case 'PAUSE':
          this.buttonStatus = 5;
          break;
        case 'FINISH':
          this.buttonStatus = 6;
          break;
        case 'EVALUATED':
          this.buttonStatus = 7;
          break;
        case 'VERIFIED':
          this.buttonStatus = 8;
          break;
        case 'ARCHIVED':
          this.buttonStatus = 9;
          break;
        case 'CLOSED':
          this.buttonStatus = 10;
          break;
      }
    },
    approveWo(){
      if(!this.woTable.currentRow){
        this.$message.error("请先选择工单");
        return;
      }
      if(!this.approveDialog.visible){
        this.approveDialog.visible = true;
        this.approveDialog.title = '工单审批 - [ '+this.woTable.currentRow.woCode+' ]';
        this.approveDialog.form.woId = this.woTable.currentRow.id;
        this.approveDialog.form.value = '1';
        this.approveDialog.form.content = '';
        return;
      }

      let me = this;
      this.$refs.approveWoForm.validate((valid) => {
        if (valid) {
          let param = this.approveDialog.form;
          $.ajax({
            url: "wo/approve",
            type: 'POST',
            data: JSON.stringify(param),
            success: function (result) {
              if(result.data){
                me.$message.success("审批成功");
                me.loadWoTable();
                me.approveDialog.visible = false;
              }
            }
          });
        }
      });

    },
    publishWo(){
      if(!this.woTable.currentRow){
        this.$message.error("请先选择工单");
        return;
      }

      let me =this;

      this.$confirm('是否发布此工单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let param = {
          woId : me.woTable.currentRow.id
        };
        $.ajax({
          url: "wo/publish",
          type: 'POST',
          data: JSON.stringify(param),
          success: function (result) {
            if(result.data){
              me.$message.success("发布成功");
              me.loadWoTable();
            }
          }
        });
      });
    },
    acceptWo(){
      if(!this.woTable.currentRow){
        this.$message.error("请先选择工单");
        return;
      }

      let me =this;

      this.$confirm('是否接受此工单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let param = {
          woId : me.woTable.currentRow.id
        };
        $.ajax({
          url: "wo/accept",
          type: 'POST',
          data: JSON.stringify(param),
          success: function (result) {
            if(result.data){
              me.$message.success("接单成功");
              me.loadWoTable();
            }
          }
        });
      });
    },
    backWo(){
      if(!this.woTable.currentRow){
        this.$message.error("请先选择工单");
        return;
      }

      let me =this;
      this.$prompt('请输入退单原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
        inputErrorMessage: '请填写退单原因'
      }).then(({ value }) => {
        let param = {
          woId:me.woTable.currentRow.id,
          content:value
        };
        $.ajax({
          url: "wo/back",
          type: 'POST',
          data: JSON.stringify(param),
          success: function (result) {
            if(result.data){
              me.$message.success("退单成功");
              me.loadWoTable();
            }
          }
        });
      });
    },
    finishWo(){
      if(!this.woTable.currentRow){
        this.$message.error("请先选择工单");
        return;
      }

      let me =this;

      this.$confirm('是否完成此工单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let param = {
          woId : me.woTable.currentRow.id
        };
        $.ajax({
          url: "wo/finish",
          type: 'POST',
          data: JSON.stringify(param),
          success: function (result) {
            if(result.data){
              me.$message.success("操作成功");
              me.loadWoTable();
            }
          }
        });
      });
    },
    evaluateWo(){
      if(!this.woTable.currentRow){
        this.$message.error("请先选择工单");
        return;
      }
      if(!this.evaluateDialog.visible){
        this.evaluateDialog.visible = true;
        this.evaluateDialog.title = '工单回访 - [ '+this.woTable.currentRow.woCode+' ]';
        this.evaluateDialog.form.woId = this.woTable.currentRow.id;
        this.evaluateDialog.form.value = 0;
        this.evaluateDialog.form.content = '';
        return;
      }

      let me = this;
      this.$refs.evaluateWoForm.validate((valid) => {
        if (valid) {
          let param = this.evaluateDialog.form;
          $.ajax({
            url: "wo/evaluate",
            type: 'POST',
            data: JSON.stringify(param),
            success: function (result) {
              if(result.data){
                me.$message.success("回访成功");
                me.loadWoTable();
                me.evaluateDialog.visible = false;
              }
            }
          });
        }
      });
    },
    verifiedWo(){
      if(!this.woTable.currentRow){
        this.$message.error("请先选择工单");
        return;
      }
      if(!this.verifiedDialog.visible){
        this.verifiedDialog.visible = true;
        this.verifiedDialog.title = '工单验证 - [ '+this.woTable.currentRow.woCode+' ]';
        this.verifiedDialog.form.woId = this.woTable.currentRow.id;
        this.verifiedDialog.form.value = '1';
        this.verifiedDialog.form.content = '';
        return;
      }

      let me = this;
      this.$refs.verifiedWoForm.validate((valid) => {
        if (valid) {
          let param = this.verifiedDialog.form;
          $.ajax({
            url: "wo/verified",
            type: 'POST',
            data: JSON.stringify(param),
            success: function (result) {
              if(result.data){
                me.$message.success("验证成功");
                me.loadWoTable();
                me.verifiedDialog.visible = false;
              }
            }
          });
        }
      });
    },
    archiveWo(){
      if(!this.woTable.currentRow){
        this.$message.error("请先选择工单");
        return;
      }

      let me =this;

      this.$confirm('是否存档此工单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let param = {
          woId : me.woTable.currentRow.id
        };
        $.ajax({
          url: "wo/archive",
          type: 'POST',
          data: JSON.stringify(param),
          success: function (result) {
            if(result.data){
              me.$message.success("存档成功");
              me.loadWoTable();
            }
          }
        });
      });
    },
    closeWo(){
      if(!this.woTable.currentRow){
        this.$message.error("请先选择工单");
        return;
      }

      let me =this;

      this.$confirm('是否终止此工单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let param = {
          woId : me.woTable.currentRow.id
        };
        $.ajax({
          url: "wo/close",
          type: 'POST',
          data: JSON.stringify(param),
          success: function (result) {
            if(result.data){
              me.$message.success("终止成功");
              me.loadWoTable();
            }
          }
        });
      });
    },
    pauseWo(){
      if(!this.woTable.currentRow){
        this.$message.error("请先选择工单");
        return;
      }

      let me =this;

      this.$prompt('请输入暂停原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
        inputErrorMessage: '请填写暂停原因'
      }).then(({ value }) => {
        let param = {
          woId:me.woTable.currentRow.id,
          content:value
        };
        $.ajax({
          url: "wo/pause",
          type: 'POST',
          data: JSON.stringify(param),
          success: function (result) {
            if(result.data){
              me.$message.success("暂停成功");
              me.loadWoTable();
            }
          }
        });
      });
    },
    resumeWo(){
      if(!this.woTable.currentRow){
        this.$message.error("请先选择工单");
        return;
      }

      let me =this;

      this.$confirm('是否恢复此工单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let param = {
          woId : me.woTable.currentRow.id
        };
        $.ajax({
          url: "wo/resume",
          type: 'POST',
          data: JSON.stringify(param),
          success: function (result) {
            if(result.data){
              me.$message.success("恢复成功");
              me.loadWoTable();
            }
          }
        });
      });
    },
    remove(id){
      let me = this;
      if(!id){
        this.$message.warning("请选择要删除的工单");
        return;
      }
      this.$confirm('是否删除此工单?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        $.ajax({
          url: "constructionProgramme/remove/"+id,
          type: 'GET',
          success: function (result) {
            me.$message.success("删除成功");
            me.loadWoTable();
          }
        });
      });
    },
    showActivity(id){
      let me = this;
      if(!id){
        this.$message.warning("请选择要查看的工单");
        return;
      }
      $.ajax({
        url: "wo/activities/"+id,
        type: 'GET',
        success: function (result) {
          if(result.data){
            me.activitiesDialog.data.woActivities = result.data;
            me.activitiesDialog.visible = true;
          }
        }
      });
    },

    openUpdateWoDialog(id){
      this.clearWoForm();
      let me = this;
      $.ajax({
        url: "constructionProgramme/info/"+id,
        type: 'POST',
        success: function (result) {
          if(result.data){
            me.woDialog.visible = true;
            me.woDialog.form = result.data;
            me.woDialog.title = "编辑工单";

          }
        }
      });
    },

    changeUpdateWoDialog(id){
      this.clearWoForm();
      let me = this;
      $.ajax({
        url: "constructionProgramme/info/"+id,
        type: 'POST',
        success: function (result) {
          if(result.data){
            me.changeDialog.visible = true;
            me.woDialog.form = result.data;
            me.changeDialog.title = "改派工单";
          }
        }
      });
    },



    detailsWoDialog(id){
      this.clearDetailsDialog();
      let me = this;
      // me.id = id;
      detailsWoDialogHOME(id)
          .then(result=>{
            if(result.data){
              me.detailsDialog.visible = true;
              me.detailsDialog.form = result.data;
              me.detailsDialog.title = "编辑";
            }
          })
    },

    handleUpdWo(){
      let me = this;
      me.copydata();
      let param = this.datanew;
      $.ajax({
        url: "constructionProgramme/upd",
        type: 'POST',
        data: JSON.stringify(param),
        success: function (result) {
          if(result.data){
            me.$message.success("保存成功");
            me.detailsDialog.visible = false;
            me.loadWoTable();
            me.clearDataNew();
            me.getAllData();
            me.getDataQty();
            me.HomeVisible = false;
          }
        }
      });


    },

    clearWoForm(){
      this.woDialog.form = {
        id:'',
        agedId:'',
        agedIdCard:'',
        agedPhone:'',
        location:'',
        woType:'',
        notices:'',
        serviceOffer:'',
        servicePersonId:'',
        serviceType:'',
        serviceCycle:'',
        planStartTime:'',
        planEndTime:'',
        serviceContent:'',
        woSource:'',
        unitPrice:'',
        priceMode:'',
        updateReason:''
      };
      if(this.$refs.woDialogForm){
        this.$nextTick(()=>{
          this.$refs.woDialogForm.clearValidate();
        })
      }
    },


    qianUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'Qian');
    },
    houUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'Hou');
    },
    qrsUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'Qrs');
    },
    xmqrsUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'Xmqrs');
    },
    aaUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'AA');
    },
    bbUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'BB');
    },
    ccUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'CC');
    },
    ddUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'DD');
    },
    eeUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'EE');
    },
    ffUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'FF');
    },
    ggUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'GG');
    },
    hhUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'HH');
    },
    iiUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'II');
    },
    jjUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'JJ');
    },
    kkUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'KK');
    },
    llUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'LL');
    },
    mmUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'MM');
    },
    nnUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'NN');
    },
    ooUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'OO');
    },
    ppUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'PP');
    },
    qqUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'QQ');
    },
    rrUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'RR');
    },
    ssUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'SS');
    },
    ttUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'TT');
    },

    uuUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'UU');
    },
    vvUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'VV');
    },
    wwUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'WW');
    },
    xxUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'XX');
    },
    yyUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'YY');
    },
    zzUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'ZZ');
    },
    aaaUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'AAA');
    },
    abbUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'ABB');
    },
    accUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'ACC');
    },
    addUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'ADD');
    },
    aeeUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'AEE');
    },
    affUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'AFF');
    },
    aggUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'AGG');
    },
    ahhUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'AHH');
    },
    aiiUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'AII');
    },
    ajjUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'AJJ');
    },
    akkUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'AKK');
    },
    allUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'ALL');
    },
    ammUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'AMM');
    },
    annUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'ANN');
    },
    aooUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'AOO');
    },
    appUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'APP');
    },
    aqqUpload(res, file) {
      let me = this;
      if (!me.id || !res.id) {
        return;
      }
      this.handleFileSuccess(me.id,res.id,'AQQ');
    },
    handleFileSuccess(agedId, fileId, type) {
      let me = this;
      if (!agedId || !fileId) {
        return;
      }
      $.ajax({
        url: "constructionProgramme/file/add",
        type: 'POST',
        data:JSON.stringify({
          constructionProgrammeId:me.id,
          fileId:fileId,
          type:type,
        }),
        success: function (result) {
          if(result.data){
            me.$message.success("上传成功");
            me.loadFiles();
          }else {
            me.$message.error("上传失败");
          }
        }
      });
    },

    removeFile(fileId){
      let me = this;
      if (!fileId) {
        return;
      }
      this.$confirm('是否移除此附件?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        $.ajax({
          url: "constructionProgramme/file/remove",
          type: 'POST',
          data:JSON.stringify({
            fileId:fileId
          }),
          success: function (result) {
            if(result.data){
              me.$message.success("移除成功");
              me.loadFiles();
            }else {
              me.$message.error("移除失败");
            }
          }
        });
      }).catch(()=>{});
    },
    loadFiles(){
      let me = this;
      if (!me.id) {
        return;
      }
      $.ajax({
        url: "constructionProgramme/"+me.id+"/files",
        type: 'POST',
        success: function (result) {
          if(result.data){
            // me.woDialog.form.files = result.data.files;
            me.detailsDialog.form.qFiles = result.data.qFiles;
            me.detailsDialog.form.hFiles = result.data.hFiles;
            me.detailsDialog.form.qrsFiles = result.data.qrsFiles;
            me.detailsDialog.form.xmqrsFiles = result.data.xmqrsFiles;

            me.detailsDialog.form.aaFiles = result.data.aaFiles;
            me.detailsDialog.form.bbFiles = result.data.bbFiles;
            me.detailsDialog.form.ccFiles = result.data.ccFiles;
            me.detailsDialog.form.ddFiles = result.data.ddFiles;
            me.detailsDialog.form.eeFiles = result.data.eeFiles;
            me.detailsDialog.form.ffFiles = result.data.ffFiles;
            me.detailsDialog.form.ggFiles = result.data.ggFiles;
            me.detailsDialog.form.hhFiles = result.data.hhFiles;
            me.detailsDialog.form.iiFiles = result.data.iiFiles;
            me.detailsDialog.form.jjFiles = result.data.jjFiles;
            me.detailsDialog.form.kkFiles = result.data.kkFiles;
            me.detailsDialog.form.llFiles = result.data.llFiles;
            me.detailsDialog.form.mmFiles = result.data.mmFiles;
            me.detailsDialog.form.nnFiles = result.data.nnFiles;
            me.detailsDialog.form.ooFiles = result.data.ooFiles;
            me.detailsDialog.form.ppFiles = result.data.ppFiles;
            me.detailsDialog.form.qqFiles = result.data.qqFiles;
            me.detailsDialog.form.rrFiles = result.data.rrFiles;
            me.detailsDialog.form.ssFiles = result.data.ssFiles;
            me.detailsDialog.form.ttFiles = result.data.ttFiles;

            me.detailsDialog.form.uuFiles = result.data.uuFiles;
            me.detailsDialog.form.vvFiles = result.data.vvFiles;
            me.detailsDialog.form.wwFiles = result.data.wwFiles;
            me.detailsDialog.form.xxFiles = result.data.xxFiles;
            me.detailsDialog.form.yyFiles = result.data.yyFiles;

            me.detailsDialog.form.zzFiles = result.data.zzFiles;
            me.detailsDialog.form.aaaFiles = result.data.aaaFiles;
            me.detailsDialog.form.abbFiles = result.data.abbFiles;
            me.detailsDialog.form.accFiles = result.data.accFiles;
            me.detailsDialog.form.addFiles = result.data.addFiles;

            me.detailsDialog.form.aeeFiles = result.data.aeeFiles;
            me.detailsDialog.form.affFiles = result.data.affFiles;
            me.detailsDialog.form.aggFiles = result.data.aggFiles;
            me.detailsDialog.form.ahhFiles = result.data.ahhFiles;
            me.detailsDialog.form.aiiFiles = result.data.aiiFiles;

          }
        }
      });
    },

    clearDetailsDialog(){
      this.detailsDialog={
        form: {
          id: '',
          agedId: '',
          agedName:'',
          idCard: '',
          agedPhone: '',
          location: '',
          agedFamilyId:'',
          agedFamilyName:'',
          servicePerson:'',
          woType: '',
          notices: '',
          serviceOffer: '',
          servicePersonId: '',
          name:'',
          serviceType: '',
          serviceCycle: '',
          planStartTime: '',
          planEndTime: '',
          workOrderContentId: '',
          serviceContent: '',
          woSource: '',
          unitPrice: '',
          priceMode: '',
          updateReason: '',
          workOrderContent:'',
          remarks:'',
          files:[],
          cFiles:[],
          wFiles:[],
          kFiles:[],
          qFiles:[],
          hFiles:[],
          qrsFiles:[],
          aaFiles:[],
          bbFiles:[],
          ccFiles:[],
          ddFiles:[],
          eeFiles:[],
          ffFiles:[],
          ggFiles:[],
          hhFiles:[],
          iiFiles:[],
          jjFiles:[],
          kkFiles:[],
          llFiles:[],
          mmFiles:[],
          nnFiles:[],
          ooFiles:[],
          ppFiles:[],
          qqFiles:[],
          rrFiles:[],
          ssFiles:[],
          ttFiles:[],

          uuFiles:[],
          vvFiles:[],
          wwFiles:[],
          xxFiles:[],
          yyFiles:[],
          zzFiles:[],
          aaaFiles:[],
          abbFiles:[],
          accFiles:[],
          addFiles:[],
          aeeFiles:[],
          affFiles:[],
          aggFiles:[],
          ahhFiles:[],
          aiiFiles:[],

          ajjFiles:[],
          akkFiles:[],
          allFiles:[],
          ammFiles:[],
          annFiles:[],
          aooFiles:[],
          appFiles:[],
          aqqFiles:[],
          examineCivil:'',
          examineProject:'',

          wangg:'',
          sos:'',
          hongw:'',
          menc:'',
          ranq:'',
          yang:'',
          shuij:'',
          fangh:'',
          hulic:'',
          chuangb:'',
          fus:'',
          muyuy:'',
          shouz:'',
          luny:'',
          zhuxq:'',
          chuangd:'',
          shexiangt:'',
          xiaoyed:'',
          shouhuan:'',
          gaocha:'',
        },
      }
    },

    copydata(){
      let me = this;
      me.datanew.id = me.detailsDialog.form.id;
      me.datanew.updateReason = me.detailsDialog.form.updateReason;
      me.datanew.wangg = me.detailsDialog.form.wangg;
      me.datanew.sos = me.detailsDialog.form.sos;
      me.datanew.hongw = me.detailsDialog.form.hongw;
      me.datanew.menc = me.detailsDialog.form.menc;
      me.datanew.ranq = me.detailsDialog.form.ranq;
      me.datanew.yang = me.detailsDialog.form.yang;
      me.datanew.shuij = me.detailsDialog.form.shuij;
      me.datanew.fangh = me.detailsDialog.form.fangh;
      me.datanew.hulic = me.detailsDialog.form.hulic;
      me.datanew.chuangb = me.detailsDialog.form.chuangb;
      me.datanew.fus = me.detailsDialog.form.fus;
      me.datanew.muyuy = me.detailsDialog.form.muyuy;
      me.datanew.shouz = me.detailsDialog.form.shouz;
      me.datanew.luny = me.detailsDialog.form.luny;
      me.datanew.zhuxq = me.detailsDialog.form.zhuxq;
      me.datanew.chuangd = me.detailsDialog.form.chuangd;
      me.datanew.shexiangt = me.detailsDialog.form.shexiangt;
      me.datanew.xiaoyed = me.detailsDialog.form.xiaoyed;
      me.datanew.shouhuan = me.detailsDialog.form.shouhuan;
      me.datanew.gaocha = me.detailsDialog.form.gaocha;
    },


    rowStyle({row, rowIndex}){
      if(!row.servicePerson){
        return {
          color:'red'
        };
      }
    },
    enumsFormatter(row, column, cellValue){
      if(this.enums && this.enums[column.property]){
        return this.enums[column.property][cellValue];
      }else {
        return cellValue;
      }
    },

    clearDataNew(){
      let me = this;
      me.AllData={
        wangg:'',
        sos:'',
        hongw:'',
        menc:'',
        ranq:'',
        yang:'',
        shuij:'',
        fangh:'',
        hulic:'',
        chuangb:'',
        fus:'',
        muyuy:'',
        shouz:'',
        luny:'',
        zhuxq:'',
        chuangd:'',
        shexiangt:'',
        xiaoyed:'',
        shouhuan:'',
        aller:'',
        gaocha:'',
      };
      me.DataDown=[];
      me.aoa = [];
    },

    //分页
    handleCurrentChange: function(val) {
      this.agedHealthTable.page.currentPage = val;
      this.getAgedTable();
    },



  }
}
</script>

<style scoped>
#home-new {
  --ink: #0f2f3a;
  --ink-raised: #17404d;
  --ink-line: rgba(255, 255, 255, 0.08);
  --ink-text: #e8f1f2;
  --ink-sub: #8fb0b8;
  --text: #17313b;
  --sub: #6b7f88;
  --line: #e3e9ec;
  --calm: #1a9985;
  --calm-bg: #e4f4f0;
  --alarm: #e5484d;
  --alarm-bg: #fdecec;
  --warn: #f0a53a;
  --num: "Bahnschrift", "DIN Alternate", "Roboto Condensed", "Microsoft YaHei", sans-serif;
  color: var(--text);
}

.desk {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 420px;
  gap: 20px;
  min-height: 660px;
}

/* ---------- 长者名册 ---------- */
.roster {
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  padding: 22px 24px 16px;
  border-radius: 18px;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(15, 47, 58, 0.06);
  box-sizing: border-box;
}

.roster-head {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 14px 24px;
  padding-bottom: 18px;
}

.roster-title {
  display: flex;
  align-items: baseline;
  gap: 12px;
}

.roster-title h2 {
  margin: 0;
  color: var(--text);
  font-size: 22px;
  line-height: 28px;
  font-weight: 800;
}

.roster-count {
  color: var(--sub);
  font-size: 13px;
}

.roster-count b {
  margin-right: 3px;
  color: var(--text);
  font-family: var(--num);
  font-size: 22px;
  font-weight: 600;
}

.roster-search {
  display: flex;
  align-items: center;
  gap: 8px;
}

.roster-search .el-input {
  width: 128px;
}

.roster-search .search-card {
  width: 170px;
}

.roster-search .search-location {
  width: 190px;
}

.roster-search >>> .el-input__inner {
  height: 34px;
  line-height: 34px;
  border-color: transparent;
  border-radius: 10px;
  background: #f1f4f5;
  color: var(--text);
}

.roster-search >>> .el-input__inner:hover {
  border-color: #d5dee2;
}

.roster-search >>> .el-input__inner:focus {
  border-color: var(--ink);
  background: #ffffff;
}

.roster-search .el-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 34px;
  margin: 0;
  padding: 0 16px;
  border-radius: 10px;
  line-height: 1;
}

.roster-search .el-button--primary {
  border-color: var(--ink);
  background: var(--ink);
}

.roster-search .el-button--primary:hover,
.roster-search .el-button--primary:focus {
  border-color: var(--ink-raised);
  background: var(--ink-raised);
}

.roster-search .search-reset {
  border-color: transparent;
  background: transparent;
  color: var(--sub);
}

.roster-search .search-reset:hover {
  color: var(--text);
  background: #f1f4f5;
}

/* 聚光灯 + 头像条 */
.stage {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
}

/* 叠放的卡片：身后两层露出边缘 */
.spot-deck {
  --mx: 0;
  --my: 0;
  position: relative;
  flex: 1;
  min-height: 340px;
  container-type: inline-size;
}

.spot-deck::before,
.spot-deck::after {
  content: "";
  position: absolute;
  z-index: 0;
  height: 40px;
  border-radius: 0 0 18px 18px;
}

.spot-deck::before {
  right: 40px;
  bottom: -16px;
  left: 40px;
  background: #dfe6e9;
}

.spot-deck::after {
  right: 20px;
  bottom: -8px;
  left: 20px;
  background: #c3ced3;
}

.spotlight {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
}

.spot-surface {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 22px 28px 28px 34px;
  border-radius: 20px;
  color: #ffffff;
  background:
    radial-gradient(90% 120% at 12% 30%, var(--hue) 0%, transparent 62%),
    linear-gradient(120deg, var(--hue-deep) 0%, #0c222b 100%);
  box-shadow: 0 18px 40px -22px var(--hue-deep);
  overflow: hidden;
  box-sizing: border-box;
  /* 透视写进 transform 自身：不用 preserve-3d，否则倾斜后按钮落到 z<0，点击被外层 .spotlight 截走 */
  transform: perspective(1600px) rotateX(calc(var(--my) * -4deg)) rotateY(calc(var(--mx) * 5deg));
  transition: transform 0.4s ease-out;
}

/* 巨型姓氏水印，随鼠标反向微移形成纵深 */
.spot-watermark {
  position: absolute;
  right: -2%;
  bottom: -22%;
  font-family: "STKaiti", "KaiTi", "楷体", serif;
  font-size: 460px;
  line-height: 1;
  color: #ffffff;
  opacity: 0.07;
  pointer-events: none;
  user-select: none;
  transform: translate(calc(var(--mx) * -18px), calc(var(--my) * -12px));
  transition: transform 0.4s ease-out;
}

.spot-top {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
}

.spot-sex,
.spot-state {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 28px;
  padding: 0 12px;
  border-radius: 14px;
  font-size: 13px;
  font-weight: 600;
  background: rgba(255, 255, 255, 0.1);
}

.spot-sex {
  color: rgba(255, 255, 255, 0.86);
}

.spot-state {
  color: #8fe3cf;
}

.state-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
}

.spotlight.is-alarm .spot-state {
  color: #ffc2c4;
  background: rgba(229, 72, 77, 0.28);
}

.spot-controls {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}

.spot-index {
  margin-right: 6px;
  font-family: var(--num);
  font-size: 14px;
  color: rgba(255, 255, 255, 0.55);
}

.spot-index b {
  font-size: 20px;
  color: #ffffff;
}

.spot-controls button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 50%;
  color: #ffffff;
  background: rgba(255, 255, 255, 0.06);
  cursor: pointer;
}

.spot-controls button:hover {
  background: rgba(255, 255, 255, 0.18);
}

.spot-body {
  position: relative;
  display: flex;
  flex: 1;
  align-items: center;
  gap: 44px;
  min-height: 0;
}

/* 字标头像：浅色同心环，告警时向外扩散红色脉冲 */
.spot-portrait {
  position: relative;
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 188px;
  height: 188px;
  border-radius: 50%;
  text-decoration: none;
  background: rgba(255, 255, 255, 0.1);
  box-shadow: 0 0 0 14px rgba(255, 255, 255, 0.05), 0 0 0 30px rgba(255, 255, 255, 0.03);
  transform: translate(calc(var(--mx) * 8px), calc(var(--my) * 6px));
  transition: transform 0.4s ease-out;
}

.spot-portrait img,
.spot-monogram,
.spot-figure {
  width: 156px;
  height: 156px;
  border-radius: 50%;
}

.spot-portrait img {
  object-fit: cover;
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.85);
}

.spot-monogram {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "STKaiti", "KaiTi", "楷体", serif;
  font-size: 88px;
  line-height: 1;
  color: #ffffff;
  background: linear-gradient(145deg, var(--hue-glow) 0%, var(--hue) 100%);
  box-shadow: inset 0 -10px 24px rgba(0, 0, 0, 0.18), 0 10px 26px -8px rgba(0, 0, 0, 0.45);
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}

/* 半身剪影：全部取长者色系，浅色头像落在色块底上，不画五官 */
.spot-figure {
  display: block;
  background: radial-gradient(circle at 50% 32%, var(--hue) 0%, var(--hue-deep) 88%);
  box-shadow: inset 0 -10px 24px rgba(0, 0, 0, 0.18), 0 10px 26px -8px rgba(0, 0, 0, 0.45);
}

.fig-skin {
  fill: #f4ede6;
}

.fig-neck {
  fill: #e4d9cf;
}

.fig-hair {
  fill: #d2d8dc;
}

.fig-body,
.fig-cap {
  fill: var(--hue-glow);
}

.fig-shirt {
  fill: #f4f1ec;
}

.fig-collar {
  fill: #ffffff;
  opacity: 0.9;
}

.fig-brim {
  fill: var(--hue-glow);
  filter: brightness(0.78);
}

.fig-band {
  fill: var(--hue-deep);
}

.fig-seam {
  fill: none;
  stroke: rgba(255, 255, 255, 0.28);
  stroke-width: 2;
}

.fig-button {
  fill: rgba(255, 255, 255, 0.55);
}

/* 剪影右下角的姓氏小印章，保留认人的线索 */
.spot-seal {
  position: absolute;
  right: 10px;
  bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  border: 3px solid var(--hue-deep);
  border-radius: 50%;
  font-family: "STKaiti", "KaiTi", "楷体", serif;
  font-size: 26px;
  line-height: 1;
  color: var(--hue-deep);
  background: #ffffff;
  box-shadow: 0 6px 14px -4px rgba(0, 0, 0, 0.45);
}

.spotlight.is-alarm .spot-portrait::before,
.spotlight.is-alarm .spot-portrait::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border: 2px solid var(--alarm);
  border-radius: 50%;
  animation: alarm-ring 2.4s ease-out infinite;
}

.spotlight.is-alarm .spot-portrait::after {
  animation-delay: 1.2s;
}

@keyframes alarm-ring {
  from {
    opacity: 0.9;
    transform: scale(0.9);
  }
  to {
    opacity: 0;
    transform: scale(1.45);
  }
}

.spot-main {
  flex: 1;
  min-width: 0;
}

.spot-name {
  margin: 0;
  overflow: hidden;
  font-size: 56px;
  font-weight: 800;
  line-height: 1.15;
  letter-spacing: 2px;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.spot-phone {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
  font-family: var(--num);
  font-size: 26px;
  letter-spacing: 1px;
  color: rgba(255, 255, 255, 0.78);
}

.spot-phone i {
  font-size: 20px;
  color: rgba(255, 255, 255, 0.5);
}

.spot-phone.is-empty {
  font-family: inherit;
  font-size: 16px;
  color: rgba(255, 255, 255, 0.5);
}

/* 年龄 + 能力等级 */
.spot-meta {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 6px;
}

.meta-age {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.7);
}

.meta-age b {
  margin-right: 2px;
  font-family: var(--num);
  font-size: 24px;
  color: #ffffff;
}

.meta-ability {
  height: 24px;
  padding: 0 10px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 600;
  line-height: 24px;
  color: rgba(255, 255, 255, 0.86);
  background: rgba(255, 255, 255, 0.12);
}

.meta-ability.is-good {
  color: #0f5b45;
  background: #a9ebd4;
}

.meta-ability.is-mild {
  color: #6b4200;
  background: #ffd98a;
}

.meta-ability.is-severe {
  color: #7a1519;
  background: #ffb4b0;
}

/* 在用设备：一类一枚，灰色为离线，琥珀点为部分离线 */
.spot-devices {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
}

.device-chip {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 14px 0 11px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 9px;
  color: #ffffff;
  background: rgba(255, 255, 255, 0.1);
  font: inherit;
  font-size: 13px;
  cursor: pointer;
  transition: background 0.2s, border-color 0.2s;
}

.device-chip i {
  font-size: 16px;
}

.device-chip em {
  font-family: var(--num);
  font-style: normal;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.62);
}

.device-chip:hover {
  border-color: rgba(255, 255, 255, 0.5);
  background: rgba(255, 255, 255, 0.2);
}

.device-dot {
  position: absolute;
  top: -3px;
  right: -3px;
  width: 9px;
  height: 9px;
  border: 2px solid var(--hue-deep);
  border-radius: 50%;
  background: #3ddc97;
}

.device-chip.is-partial .device-dot {
  background: #ffc53d;
}

.device-chip.is-offline {
  color: rgba(255, 255, 255, 0.5);
  border-style: dashed;
  background: rgba(0, 0, 0, 0.12);
}

.device-chip.is-offline .device-dot {
  background: #8a979c;
}

.device-none {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.42);
}

.spot-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 20px;
}

.spot-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 38px;
  padding: 0 20px;
  border: 1px solid rgba(255, 255, 255, 0.28);
  border-radius: 19px;
  color: #ffffff;
  background: transparent;
  font: inherit;
  font-size: 14px;
  cursor: pointer;
}

.spot-btn:hover {
  background: rgba(255, 255, 255, 0.12);
}

.spot-btn.is-primary {
  border-color: #ffffff;
  color: var(--hue-deep);
  background: #ffffff;
  font-weight: 700;
}

.spot-btn.is-primary:hover {
  background: rgba(255, 255, 255, 0.88);
}

/* 近期告警：只在有记录时出现，半透明玻璃浮在水印上 */
.spot-events {
  display: flex;
  flex: none;
  flex-direction: column;
  width: 340px;
  max-height: 100%;
  padding: 18px 18px 12px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(8px);
  box-sizing: border-box;
}

/* 卡片较窄（小屏 + 侧栏展开）时收起近期告警，避免把姓名、设备和按钮挤出卡片 */
@container (max-width: 860px) {
  .spot-events {
    display: none;
  }
}

.spot-events h4 {
  margin: 0 0 10px;
  font-size: 14px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.72);
}

.spot-events ol {
  flex: 1;
  margin: 0;
  padding: 0;
  overflow-y: auto;
  list-style: none;
}

.spot-events li {
  display: grid;
  grid-template-columns: 50px minmax(0, 1fr);
  gap: 10px;
  padding: 9px 0 9px 12px;
  border-left: 2px solid rgba(255, 255, 255, 0.2);
  font-size: 13px;
  line-height: 1.55;
}

.spot-events li + li {
  margin-top: 4px;
}

.spot-events li.level-danger {
  border-left-color: var(--alarm);
}

.spot-events li.level-warning {
  border-left-color: var(--warn);
}

.spot-event-time b {
  display: block;
  font-family: var(--num);
  font-size: 16px;
}

.spot-event-time small {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
}

.spot-event-text {
  color: rgba(255, 255, 255, 0.82);
}

.spot-progress {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3px;
  width: 100%;
  background: linear-gradient(90deg, var(--hue-glow), #ffffff);
  transform-origin: left center;
  animation: spot-progress linear forwards;
}

.spot-progress.is-paused {
  animation-play-state: paused;
}

.spotlight.is-alarm .spot-progress {
  background: var(--alarm);
}

@keyframes spot-progress {
  from {
    transform: scaleX(0);
  }
  to {
    transform: scaleX(1);
  }
}

/* 切换过场：新长者的底色从头像处晕开盖住旧卡，内容随后依次浮现；
   子元素用独立的 translate/scale 属性，和倾斜视差的 transform 叠加而不互相覆盖 */
.spot-surface {
  --ox: 128px;
  --oy: 56%;
}

.spot-ink-enter-active {
  z-index: 2;
}

.spot-ink-leave-active {
  z-index: 0;
}

.spot-ink-enter-active .spot-surface {
  animation: spot-ink 0.9s cubic-bezier(0.65, 0, 0.35, 1) both;
}

.spot-ink-enter-active .spot-watermark {
  animation: spot-drift 1.2s cubic-bezier(0.2, 0.8, 0.25, 1) 0.15s both;
}

.spot-ink-enter-active .spot-portrait {
  animation: spot-pop 0.7s cubic-bezier(0.34, 1.5, 0.64, 1) 0.2s both;
}

.spot-ink-enter-active .spot-sex,
.spot-ink-enter-active .spot-state,
.spot-ink-enter-active .spot-name,
.spot-ink-enter-active .spot-meta,
.spot-ink-enter-active .spot-phone,
.spot-ink-enter-active .spot-devices,
.spot-ink-enter-active .spot-actions {
  animation: spot-rise 0.6s cubic-bezier(0.2, 0.8, 0.25, 1) both;
}

.spot-ink-enter-active .spot-sex,
.spot-ink-enter-active .spot-state {
  animation-delay: 0.25s;
}

.spot-ink-enter-active .spot-name {
  animation-delay: 0.3s;
}

.spot-ink-enter-active .spot-meta {
  animation-delay: 0.34s;
}

.spot-ink-enter-active .spot-phone {
  animation-delay: 0.38s;
}

.spot-ink-enter-active .spot-devices {
  animation-delay: 0.44s;
}

.spot-ink-enter-active .spot-actions {
  animation-delay: 0.5s;
}

.spot-ink-enter-active .spot-events {
  animation: spot-slide 0.7s cubic-bezier(0.2, 0.8, 0.25, 1) 0.5s both;
}

/* 旧卡内容先沉下去，只留底色给晕染覆盖；右上角控制条两张卡一致，保持不动 */
.spot-ink-leave-active .spot-sex,
.spot-ink-leave-active .spot-state,
.spot-ink-leave-active .spot-body {
  animation: spot-sink 0.35s ease-in both;
}

@keyframes spot-ink {
  from {
    clip-path: circle(0 at var(--ox) var(--oy));
  }
  to {
    clip-path: circle(150% at var(--ox) var(--oy));
  }
}

@keyframes spot-drift {
  from {
    opacity: 0;
    translate: calc(var(--dir, 1) * 80px) 0;
    scale: 1.08;
  }
}

@keyframes spot-pop {
  from {
    opacity: 0;
    scale: 0.8;
  }
}

@keyframes spot-rise {
  from {
    opacity: 0;
    translate: 0 16px;
  }
}

@keyframes spot-slide {
  from {
    opacity: 0;
    translate: 24px 0;
  }
}

@keyframes spot-sink {
  to {
    opacity: 0;
    translate: 0 10px;
  }
}

@media (max-width: 1500px) {
  .spot-surface {
    --ox: 101px;
  }
}

/* 头像条：Cover Flow */
.strip {
  margin-top: 26px;
}

.strip-list {
  position: relative;
  height: 118px;
  margin: 0;
  padding: 0;
  list-style: none;
  perspective: 700px;
}

.strip-list li {
  position: absolute;
  top: 14px;
  width: 84px;
  margin-left: -42px;
  transition: left 0.6s cubic-bezier(0.22, 0.8, 0.3, 1), transform 0.6s cubic-bezier(0.22, 0.8, 0.3, 1), opacity 0.4s ease;
}

.strip-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 0;
  border: 0;
  color: var(--text);
  background: transparent;
  cursor: pointer;
  font: inherit;
}

.strip-photo {
  position: relative;
  display: flex;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  box-shadow: 0 8px 16px -8px rgba(15, 47, 58, 0.5);
}

.strip-photo img,
.strip-monogram {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.strip-photo img {
  object-fit: cover;
}

.strip-monogram {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "STKaiti", "KaiTi", "楷体", serif;
  font-size: 30px;
  line-height: 1;
  color: #ffffff;
  background: linear-gradient(145deg, var(--hue-glow) 0%, var(--hue) 100%);
}

.strip-item.is-alarm .strip-photo {
  box-shadow: 0 0 0 2px #ffffff, 0 0 0 4px var(--alarm);
}

.strip-belt {
  position: absolute;
  right: -3px;
  bottom: -3px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border: 2px solid #ffffff;
  border-radius: 50%;
  font-size: 11px;
  color: #ffffff;
  background: #6b5bd6;
}

.strip-name {
  max-width: 100%;
  overflow: hidden;
  font-size: 13px;
  line-height: 18px;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: var(--sub);
}

.strip-item:hover .strip-name {
  color: var(--text);
}

.strip-item.is-active .strip-photo {
  box-shadow: 0 0 0 3px #ffffff, 0 0 0 5px var(--hue), 0 12px 22px -8px var(--hue-deep);
}

.strip-item.is-active.is-alarm .strip-photo {
  box-shadow: 0 0 0 3px #ffffff, 0 0 0 5px var(--alarm), 0 12px 22px -8px var(--hue-deep);
}

.strip-item.is-active .strip-name {
  font-weight: 700;
  color: var(--text);
}

.strip-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-top: 6px;
}

.strip-caption {
  font-size: 13px;
  color: var(--sub);
}

.strip-foot >>> .el-pager li {
  font-family: var(--num);
  font-size: 13px;
}

.strip-foot >>> .el-pager li.active {
  color: var(--calm);
}

.stage a:focus-visible,
.stage button:focus-visible,
.console a:focus-visible,
.console button:focus-visible {
  outline: 2px solid var(--calm);
  outline-offset: 2px;
}

.roster-empty {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 260px;
  color: var(--sub);
}

.roster-empty i {
  font-size: 40px;
  color: #c7d2d6;
}

.roster-empty p {
  margin: 12px 0 16px;
}

/* ---------- 值守台 ---------- */
.console {
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding: 20px 20px 16px;
  border-radius: 18px;
  background: var(--ink);
  color: var(--ink-text);
  box-sizing: border-box;
}

.console-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 14px;
}

.console-title {
  display: flex;
  align-items: center;
  gap: 10px;
}

.console-title h3,
.stats-head h3 {
  margin: 0;
  color: var(--ink-text);
  font-size: 17px;
  line-height: 24px;
  font-weight: 800;
}

.live-dot {
  position: relative;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--alarm);
}

.live-dot::after {
  content: "";
  position: absolute;
  inset: -4px;
  border-radius: 50%;
  border: 2px solid var(--alarm);
  animation: live-pulse 1.8s ease-out infinite;
}

@keyframes live-pulse {
  from { transform: scale(0.6); opacity: 0.9; }
  to { transform: scale(1.8); opacity: 0; }
}

.console-refresh {
  width: 30px;
  height: 30px;
  padding: 0;
  border: 1px solid var(--ink-line);
  border-radius: 8px;
  color: var(--ink-sub);
  background: transparent;
  cursor: pointer;
  font-size: 15px;
}

.console-refresh:hover {
  color: var(--ink-text);
  background: var(--ink-raised);
}

.feed {
  flex: 1;
  min-height: 0;
  margin: 0 -8px;
  padding: 0 8px;
  overflow-y: auto;
}

.feed-latest {
  display: block;
  padding: 14px 16px 16px;
  border-radius: 14px;
  background: var(--ink-raised);
  box-shadow: inset 3px 0 0 var(--ink-sub);
  color: var(--ink-text);
  text-decoration: none;
}

.feed-latest.level-danger {
  background: linear-gradient(100deg, rgba(229, 72, 77, 0.28), var(--ink-raised) 70%);
  box-shadow: inset 3px 0 0 var(--alarm);
}

.feed-latest.level-warning {
  background: linear-gradient(100deg, rgba(240, 165, 58, 0.24), var(--ink-raised) 70%);
  box-shadow: inset 3px 0 0 var(--warn);
}

.feed-latest-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.feed-latest-tag {
  padding: 1px 8px;
  border-radius: 6px;
  color: #ffffff;
  background: rgba(255, 255, 255, 0.14);
  font-size: 12px;
  line-height: 18px;
  font-weight: 700;
}

.feed-latest-time {
  color: var(--ink-sub);
  font-family: var(--num);
  font-size: 13px;
}

.feed-latest-name {
  margin-top: 10px;
  font-size: 22px;
  line-height: 28px;
  font-weight: 800;
}

.feed-latest-text {
  margin: 4px 0 0;
  color: #cfe0e3;
  font-size: 14px;
  line-height: 21px;
}

.feed-list {
  margin: 10px 0 0;
  padding: 0;
  list-style: none;
}

.feed-item {
  display: grid;
  grid-template-columns: 52px 14px minmax(0, 1fr);
  gap: 8px;
  padding: 10px 8px;
  border-radius: 10px;
  color: #cfe0e3;
  text-decoration: none;
}

.feed-item:hover {
  background: rgba(255, 255, 255, 0.05);
}

.feed-time {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  font-family: var(--num);
  line-height: 16px;
}

.feed-time b {
  color: var(--ink-text);
  font-size: 15px;
  font-weight: 600;
}

.feed-time small {
  margin-top: 2px;
  color: var(--ink-sub);
  font-size: 11px;
}

.feed-rail {
  position: relative;
  display: flex;
  justify-content: center;
}

.feed-rail::before {
  content: "";
  width: 8px;
  height: 8px;
  margin-top: 4px;
  border-radius: 50%;
  background: var(--ink-sub);
}

.level-danger .feed-rail::before {
  background: var(--alarm);
}

.level-warning .feed-rail::before {
  background: var(--warn);
}

.feed-body {
  display: -webkit-box;
  overflow: hidden;
  font-size: 13px;
  line-height: 20px;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.feed-body b {
  margin-right: 4px;
  color: var(--ink-text);
  font-weight: 800;
}

.feed-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 160px;
  color: var(--ink-sub);
}

.feed-empty i {
  font-size: 36px;
  color: var(--calm);
}

.feed-empty p {
  margin: 10px 0 0;
}

.stats {
  flex: 0 0 auto;
  margin-top: 14px;
  padding-top: 16px;
  border-top: 1px solid var(--ink-line);
}

.stats-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
}

.stats-total {
  color: var(--ink-sub);
  font-size: 12px;
}

.stats-total b {
  margin-right: 3px;
  color: var(--ink-text);
  font-family: var(--num);
  font-size: 20px;
  font-weight: 600;
}

.stats-chart {
  width: 100%;
  height: 220px;
  margin-top: 8px;
}

.spot-events ol::-webkit-scrollbar,
.feed::-webkit-scrollbar {
  width: 6px;
}

.spot-events ol::-webkit-scrollbar-thumb,
.feed::-webkit-scrollbar-thumb {
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.14);
}

@media (max-width: 1500px) {
  .desk {
    grid-template-columns: minmax(0, 1fr) 360px;
  }

  .roster-search .el-input {
    width: 110px;
  }

  .roster-search .search-card,
  .roster-search .search-location {
    width: 140px;
  }
}

@media (max-width: 1500px) {
  .spot-surface {
    padding: 20px 22px 24px 26px;
  }

  .spot-body {
    gap: 30px;
  }

  .spot-portrait {
    width: 150px;
    height: 150px;
  }

  .spot-portrait img,
  .spot-monogram,
  .spot-figure {
    width: 124px;
    height: 124px;
  }

  .spot-seal {
    right: 6px;
    bottom: 8px;
    width: 38px;
    height: 38px;
    font-size: 21px;
  }

  .spot-monogram {
    font-size: 70px;
  }

  .spot-watermark {
    font-size: 380px;
  }

  .spot-name {
    font-size: 42px;
  }

  .spot-phone {
    font-size: 22px;
  }

  .device-chip {
    height: 30px;
    padding: 0 11px 0 9px;
  }

  .spot-actions {
    margin-top: 16px;
  }

  .spot-events {
    width: 290px;
  }
}

/* 设备详情弹窗 */
.radar-card + .radar-card {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #eef1f2;
}

.radar-head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  font-size: 13px;
  color: #6b7a80;
}

.radar-imei {
  font-family: var(--num);
  color: #26363c;
}

.radar-time {
  margin-left: auto;
}

.radar-tip {
  padding: 28px 0;
  text-align: center;
  color: #8a979c;
}

.radar-tip i {
  margin-right: 6px;
}

.radar-presence {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
  padding: 12px 16px;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 700;
  color: #0f5b45;
  background: #e6f7f0;
}

.radar-presence.is-empty {
  color: #6b7a80;
  background: #f3f5f6;
}

.radar-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  margin: 12px 0 0;
}

.radar-grid div {
  padding: 12px 14px;
  border: 1px solid #eef1f2;
  border-radius: 10px;
}

.radar-grid dt {
  font-size: 12px;
  color: #8a979c;
}

.radar-grid dd {
  margin: 6px 0 0;
  font-size: 15px;
  font-weight: 600;
  color: #26363c;
}

.radar-grid dd b {
  font-family: var(--num);
  font-size: 26px;
}

.radar-grid dd small {
  margin-left: 4px;
  font-size: 12px;
  font-weight: 400;
  color: #8a979c;
}

.device-state {
  display: inline-block;
  padding: 0 8px;
  border-radius: 10px;
  font-size: 12px;
  line-height: 20px;
}

.device-state.is-online {
  color: #0f7a55;
  background: #e1f6ec;
}

.device-state.is-offline {
  color: #7b878c;
  background: #eef1f2;
}

.device-cell-icon {
  margin-right: 6px;
  color: #6b7a80;
}

.device-dialog-table >>> .el-table__row.is-picked td {
  background: #f1f8fb;
}

@media (prefers-reduced-motion: reduce) {
  .live-dot::after,
  .spotlight.is-alarm .spot-portrait::before,
  .spotlight.is-alarm .spot-portrait::after {
    animation: none;
  }

  .spot-progress {
    display: none;
  }

  .spot-surface,
  .spot-watermark,
  .spot-portrait {
    transform: none;
  }

  .strip-list li {
    transition: none;
  }

  .spot-ink-enter-active .spot-surface,
  .spot-ink-enter-active .spot-watermark,
  .spot-ink-enter-active .spot-portrait,
  .spot-ink-enter-active .spot-sex,
  .spot-ink-enter-active .spot-state,
  .spot-ink-enter-active .spot-name,
  .spot-ink-enter-active .spot-meta,
  .spot-ink-enter-active .spot-phone,
  .spot-ink-enter-active .spot-devices,
  .spot-ink-enter-active .spot-actions,
  .spot-ink-enter-active .spot-events,
  .spot-ink-leave-active .spot-sex,
  .spot-ink-leave-active .spot-state,
  .spot-ink-leave-active .spot-body {
    animation: none;
  }
}

</style>
